/*
 * @license
 * Story Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s, o, n, r, a, l, c) {
    "use strict";
    function h(t) {
        var e = Object.create(null);
        return (
            t &&
                Object.keys(t).forEach(function (i) {
                    if ("default" !== i) {
                        var s = Object.getOwnPropertyDescriptor(t, i);
                        Object.defineProperty(
                            e,
                            i,
                            s.get
                                ? s
                                : {
                                      enumerable: !0,
                                      get: function () {
                                          return t[i];
                                      },
                                  }
                        );
                    }
                }),
            (e.default = t),
            Object.freeze(e)
        );
    }
    var d = h(o);
    function u(t, e) {
        let i;
        return (...s) => {
            clearTimeout(i), (i = setTimeout(() => t.apply(this, s), e));
        };
    }
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = { small: 480, medium: 768, large: 990, widescreen: 1400 }),
        (window.theme.keyboardKeys = { TAB: 9, ENTER: 13, ESCAPE: 27, SPACE: 32, LEFTARROW: 37, RIGHTARROW: 39 });
    let p = window.innerWidth;
    let m = window.pageYOffset,
        y = null,
        f = null,
        g = null,
        v = null,
        w = 0;
    function b(e) {
        setTimeout(() => {
            w && clearTimeout(w), t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function S(t) {
        const e = t.detail;
        e ? (w = setTimeout(E, e)) : E();
    }
    function E() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    function L(t) {
        const e = t.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        e.forEach((t) => {
            i.querySelector(`[id="${t.id}"]`) ? t.parentNode.removeChild(t) : i.appendChild(t);
        });
    }
    function k(t) {
        t.querySelectorAll(".form__field").forEach((t) => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e &&
                i &&
                i.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                i && i.value && i.value.length && e.classList.add("label--float");
        });
    }
    function T(t) {
        t.querySelectorAll(".errors").forEach((t) => {
            t.setAttribute("tabindex", "0"), t.setAttribute("aria-live", "assertive"), t.setAttribute("role", "alert");
        });
    }
    function A() {
        const t = {};
        return (
            (t.windowHeight = window.innerHeight),
            (t.announcementHeight = C("#shopify-section-announcement")),
            (t.footerHeight = C('[data-section-type*="footer"]')),
            (t.menuHeight = C("[data-header-height]")),
            (t.headerHeight = t.menuHeight + t.announcementHeight),
            (t.logoHeight = (function () {
                const t = C("[data-footer-logo]");
                return t > 0 ? t + 20 : 0;
            })()),
            t
        );
    }
    function q() {
        document.addEventListener("theme:resize", x),
            (function () {
                const { windowHeight: t, announcementHeight: e, headerHeight: i, logoHeight: s, menuHeight: o, footerHeight: n } = A();
                document.documentElement.style.setProperty("--full-screen", `${t}px`),
                    document.documentElement.style.setProperty("--three-quarters", 0.75 * t + "px"),
                    document.documentElement.style.setProperty("--two-thirds", 0.66 * t + "px"),
                    document.documentElement.style.setProperty("--one-half", 0.5 * t + "px"),
                    document.documentElement.style.setProperty("--one-third", 0.33 * t + "px"),
                    document.documentElement.style.setProperty("--one-fifth", 0.2 * t + "px"),
                    document.documentElement.style.setProperty("--menu-height", `${o}px`),
                    document.documentElement.style.setProperty("--announcement-height", `${e}px`),
                    document.documentElement.style.setProperty("--header-height", `${i}px`),
                    document.documentElement.style.setProperty("--footer-height", `${n}px`),
                    document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"),
                    document.documentElement.style.setProperty("--content-min", t - i - n + "px"),
                    document.documentElement.style.setProperty("--scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
            })();
    }
    function x() {
        const { windowHeight: t, announcementHeight: e, headerHeight: i, logoHeight: s, menuHeight: o, footerHeight: n } = A();
        document.documentElement.style.setProperty("--menu-height", `${o}px`),
            document.documentElement.style.setProperty("--announcement-height", `${e}px`),
            document.documentElement.style.setProperty("--header-height", `${i}px`),
            document.documentElement.style.setProperty("--footer-height", `${n}px`),
            document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"),
            document.documentElement.style.setProperty("--content-min", t - i - n + "px");
    }
    function C(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function P(t, e) {
        let i = 64,
            s = 0;
        e.forEach((t) => {
            if (t.offsetHeight > s) {
                const e = parseInt(window.getComputedStyle(t).marginTop) + parseInt(window.getComputedStyle(t).marginBottom);
                e > i && (i = e), (s = t.offsetHeight);
            }
        });
        const o = t.querySelectorAll("[data-overflow-background]");
        [t, ...o].forEach((t) => {
            t.style.setProperty("min-height", `calc(${s + i}px + var(--menu-height))`);
        });
    }
    function $(t) {
        if (window.innerWidth < window.theme.sizes.medium) {
            return void t.querySelectorAll("[data-overflow-frame]").forEach((t) => {
                const e = t.querySelectorAll("[data-overflow-content]");
                P(t, e);
            });
        }
        const e = 2 * parseInt(getComputedStyle(t).getPropertyValue("--outer"));
        let i = 0;
        const s = t.querySelectorAll("[data-overflow-frame]");
        t.querySelectorAll("[data-overflow-content]").forEach((t) => {
            t.offsetHeight > i && (i = t.offsetHeight);
        });
        [...s, ...t.querySelectorAll("[data-overflow-background]")].forEach((t) => {
            t.style.setProperty("min-height", `${i + e}px`);
        }),
            t.style.setProperty("min-height", `${i + e}px`);
    }
    function _(t) {
        const i = t.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((t) => {
                const e = t.querySelectorAll(".js-overflow-content");
                P(t, e),
                    document.addEventListener("theme:resize", () => {
                        P(t, e);
                    });
            });
            const s = t.querySelectorAll("[data-slideshow-wrapper]");
            s.length &&
                s.forEach((t) => {
                    const i = e.data(t);
                    void 0 !== i && i.reloadCells();
                });
        }
        const s = t.querySelectorAll("[data-overflow-wrapper]");
        s &&
            s.forEach((t) => {
                $(t),
                    document.addEventListener("theme:resize", () => {
                        $(t);
                    });
            });
    }
    window.addEventListener(
        "resize",
        u(function () {
            document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })), window.innerWidth != p && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (p = window.innerWidth));
        }, 50)
    ),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.pageYOffset;
                                t > m ? ((f = !0), (y = !1)) : t < m ? ((f = !1), (y = !0)) : ((y = null), (f = null)),
                                    (m = t),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: y, down: f, position: t }, bubbles: !1 })),
                                    y && !g && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                    f && !v && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                    (v = f),
                                    (g = y);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", b),
                window.addEventListener("theme:scroll:unlock", S);
        })(),
        window.addEventListener("load", () => {
            q(), k(document), T(document), L(document), _(document);
        }),
        document.addEventListener("shopify:section:load", (t) => {
            document.dispatchEvent(new CustomEvent("theme:header:check", { bubbles: !1 }));
            const e = t.target;
            k(e), T(e), L(e), _(e);
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:check", { bubbles: !1 }));
        });
    const D = {
            templateAddresses: ".template-addresses",
            addressNewForm: "#AddressNewForm",
            btnNew: "[data-btn-address-toggle]",
            btnEdit: "[data-btn-address-edit-toggle]",
            btnDelete: "[data-btn-address-delete]",
            addressCountrySelect: "[data-country-select]",
            defaultConfirmMessage: "Are you sure you wish to delete this address?",
            editAddress: "#EditAddress",
            dataFormId: "data-form-id",
            addressCountryNew: "AddressCountryNew",
            addressProvinceNew: "AddressProvinceNew",
            addressProvinceContainerNew: "AddressProvinceContainerNew",
            addressCountry: "AddressCountry",
            addressProvince: "AddressProvince",
            addressProvinceContainer: "AddressProvinceContainer",
        },
        I = "hide";
    document.addEventListener("DOMContentLoaded", function () {
        const t = document.querySelector(D.templateAddresses);
        t &&
            new (class {
                events() {
                    this.newButtons.length &&
                        this.newButtons.forEach((t) => {
                            t.addEventListener("click", () => {
                                this.addressNewForm.classList.toggle(I);
                            });
                        }),
                        this.editButtons.length &&
                            this.editButtons.forEach((t) => {
                                t.addEventListener("click", () => {
                                    const e = t.getAttribute(D.dataFormId);
                                    this.section.querySelector(`${D.editAddress}_${e}`).classList.toggle(I);
                                });
                            }),
                        this.deleteButtons.length &&
                            this.deleteButtons.forEach((t) => {
                                t.addEventListener("click", () => {
                                    const e = t.getAttribute(D.dataFormId),
                                        i = t.getAttribute(D.dataConfirmMessage);
                                    confirm(i || D.defaultConfirmMessage) && Shopify.postLink(`${theme.routes.account_addresses_url}/${e}`, { parameters: { _method: "delete" } });
                                });
                            });
                }
                customerAddresses() {
                    Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(D.addressCountryNew, D.addressProvinceNew, { hideElement: D.addressProvinceContainerNew }),
                        this.countrySelects.forEach((t) => {
                            const e = t.getAttribute(D.dataFormId),
                                i = `${D.addressCountry}_${e}`,
                                s = `${D.addressProvince}_${e}`,
                                o = `${D.addressProvinceContainer}_${e}`;
                            new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                        });
                }
                constructor(t) {
                    (this.section = t),
                        (this.addressNewForm = this.section.querySelector(D.addressNewForm)),
                        (this.newButtons = this.section.querySelectorAll(D.btnNew)),
                        (this.editButtons = this.section.querySelectorAll(D.btnEdit)),
                        (this.deleteButtons = this.section.querySelectorAll(D.btnDelete)),
                        (this.countrySelects = this.section.querySelectorAll(D.addressCountrySelect)),
                        this.addressNewForm && (this.customerAddresses(), this.events());
                }
            })(t);
    });
    const M = "[data-account-form]",
        H = "[data-show-reset]",
        F = "[data-hide-reset]",
        B = "[data-recover-password]",
        W = "[data-login-form]",
        O = "#recover",
        N = "hide";
    document.addEventListener("DOMContentLoaded", function () {
        const t = document.querySelector(M);
        t &&
            new (class {
                init() {
                    window.location.hash == O ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                        this.showButton.addEventListener("click", (t) => {
                            t.preventDefault(), this.showRecoverPasswordForm();
                        }),
                        this.hideButton.addEventListener("click", (t) => {
                            t.preventDefault(), this.hideRecoverPasswordForm();
                        });
                }
                showRecoverPasswordForm() {
                    return this.login.classList.add(N), this.recover.classList.remove(N), (window.location.hash = O), !1;
                }
                hideRecoverPasswordForm() {
                    return this.recover.classList.add(N), this.login.classList.remove(N), (window.location.hash = ""), !1;
                }
                constructor(t) {
                    (this.showButton = t.querySelector(H)), (this.hideButton = t.querySelector(F)), (this.recover = t.querySelector(B)), (this.login = t.querySelector(W)), this.init();
                }
            })(t);
    }),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const z = window.Shopify.theme.sections.registered,
        V = window.Shopify.theme.sections.instances,
        R = "data-section-id",
        j = "data-section-type";
    let U = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t) => {
                const i = { id: this.id, type: this.type, container: this.container };
                e ? t.call(i, e) : t.call(i);
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(t) {
            this.callFunctions("onSelect", t);
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t);
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t);
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t);
        }
        onReorder(t) {
            this.callFunctions("onReorder", t);
        }
        constructor(t, e) {
            (this.container = (function (t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(R)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + R + " attribute.");
                return t;
            })(t)),
                (this.id = t.getAttribute(R)),
                (this.type = e.type),
                (this.callStack = e.getStack());
            try {
                this.onLoad();
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
            }
        }
    };
    function J(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== z[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new (class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        })(t, e);
        return (z[t] = i), z;
    }
    function Y(t, e) {
        (t = Q(t)),
            void 0 === e && (e = document.querySelectorAll("[" + j + "]")),
            (e = G(e)),
            t.forEach(function (t) {
                const i = z[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return !(K(e).length > 0) && null !== e.getAttribute(j) && (e.getAttribute(j) !== t || (V.push(new U(e, i)), !1));
                    }));
            });
    }
    function K(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            G(t).forEach(function (t) {
                e = e.concat(
                    V.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            Q(t).forEach(function (t) {
                e = e.concat(
                    V.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function X(t) {
        for (var e, i = 0; i < V.length; i++)
            if (V[i].id === t) {
                e = V[i];
                break;
            }
        return e;
    }
    function Q(t) {
        return (
            "*" === t
                ? (t = Object.keys(z))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === U
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === U &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function G(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    function Z(t, e) {
        (e = e || {}),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function i(s) {
                s.target.removeEventListener(s.type, i), void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function tt(t) {
        t = t || {};
        var e = window.location.hash,
            i = document.getElementById(e.slice(1));
        if (i && t.ignore && i.matches(t.ignore)) return !1;
        e && i && Z(i, t);
    }
    function et(t) {
        return (
            (t = t || {}),
            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                var i,
                    s = document.querySelector(e.hash);
                return (
                    !!s &&
                    (e.addEventListener("click", function () {
                        Z(s, t);
                    }),
                    !0)
                );
            })
        );
    }
    function it(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter(function (t) {
            return Boolean(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
        });
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + R + '="' + e + '"]');
            null !== i && Y(i.getAttribute(j), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + R + '="' + e + '"]');
            "object" == typeof K(i)[0] &&
                K(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + R + '="' + e + '"]');
            "object" == typeof K(i)[0] &&
                K(i).forEach(function (t) {
                    var e = V.map(function (t) {
                        return t.id;
                    }).indexOf(t.id);
                    V.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = X(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    var st = {};
    function ot(t, e) {
        e = e || {};
        var i = it(t),
            s = e.elementToFocus || t,
            o = i[0],
            n = i[i.length - 1];
        nt(),
            (st.focusin = function (e) {
                t !== e.target && !t.contains(e.target) && o && o.focus(), (e.target !== t && e.target !== n && e.target !== o) || document.addEventListener("keydown", st.keydown);
            }),
            (st.focusout = function () {
                document.removeEventListener("keydown", st.keydown);
            }),
            (st.keydown = function (e) {
                9 === e.keyCode && (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()), (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
            }),
            document.addEventListener("focusout", st.focusout),
            document.addEventListener("focusin", st.focusin),
            Z(s, e);
    }
    function nt() {
        document.removeEventListener("focusin", st.focusin), document.removeEventListener("focusout", st.focusout), document.removeEventListener("keydown", st.keydown);
    }
    var rt = Object.freeze({
            __proto__: null,
            forceFocus: Z,
            focusHash: tt,
            bindInPageLinks: et,
            focusable: it,
            trapFocus: ot,
            removeTrapFocus: nt,
            accessibleLinks: function (t, e) {
                if ("string" != typeof t) throw new TypeError(t + " is not a String.");
                if (0 !== (t = document.querySelectorAll(t)).length) {
                    (e = e || {}).messages = e.messages || {};
                    var i,
                        s,
                        o,
                        n = {
                            newWindow: e.messages.newWindow || "Opens in a new window.",
                            external: e.messages.external || "Opens external website.",
                            newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
                        },
                        r = e.prefix || "a11y",
                        a = { newWindow: r + "-new-window-message", external: r + "-external-message", newWindowExternal: r + "-new-window-external-message" };
                    t.forEach(function (t) {
                        var e = t.getAttribute("target"),
                            i = t.getAttribute("rel"),
                            s = (function (t) {
                                return t.hostname !== window.location.hostname;
                            })(t),
                            o = "_blank" === e,
                            n = null === i || -1 === i.indexOf("noopener");
                        if (o && n) {
                            var r = null === i ? "noopener" : i + " noopener";
                            t.setAttribute("rel", r);
                        }
                        s && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : s ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow);
                    }),
                        (i = n),
                        (s = document.createElement("ul")),
                        (o = Object.keys(i).reduce(function (t, e) {
                            return t + "<li id=" + a[e] + ">" + i[e] + "</li>";
                        }, "")),
                        s.setAttribute("hidden", !0),
                        (s.innerHTML = o),
                        document.body.appendChild(s);
                }
            },
        }),
        at = "data-drawer",
        lt = "[data-scroll-lock-scrollable]",
        ct = "[data-drawer-underlay]",
        ht = "[data-stagger-animation]",
        dt = "[data-header-wrapper]",
        ut = "data-drawer-toggle",
        pt = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        mt = "has-drawer-open",
        yt = "drawer--visible",
        ft = "display-none",
        gt = "js__show__mobile",
        vt = {};
    const wt = {
            onLoad() {
                vt[this.id] = [];
                this.container.querySelectorAll(`[${at}]`).forEach((t) => {
                    vt[this.id].push(
                        new (class {
                            unload() {}
                            connectToggle() {
                                this.buttons.forEach((t) => {
                                    t.addEventListener(
                                        "click",
                                        function (t) {
                                            t.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                                        }.bind(this)
                                    );
                                });
                            }
                            connectDrawer() {
                                this.drawer.addEventListener(
                                    "theme:drawer:toggle",
                                    function () {
                                        this.drawer.classList.contains(yt)
                                            ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !1 }))
                                            : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                    }.bind(this)
                                ),
                                    this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)),
                                    this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this));
                            }
                            staggerChildAnimations() {
                                this.staggers.forEach((t) => {
                                    t.querySelectorAll(":scope > * > * > [data-animates]").forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    });
                                });
                            }
                            closers() {
                                this.drawer.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(), this.buttons[0].focus());
                                    }.bind(this)
                                ),
                                    this.underlay.addEventListener(
                                        "click",
                                        function () {
                                            this.hideDrawer();
                                        }.bind(this)
                                    );
                            }
                            showDrawer() {
                                setTimeout(() => {
                                    this.drawer.classList.remove(ft),
                                        this.buttons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                        this.drawer.classList.add(yt),
                                        this.drawerScrolls && document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                    const t = this.drawer.querySelector(pt);
                                    ot(this.drawer, { elementToFocus: t });
                                }, 1),
                                    "hamburger" === this.key && (document.querySelector(`[${at}="drawer-cart"]`).classList.remove(yt), this.outer.classList.add(mt)),
                                    "drawer-cart" === this.key && (document.querySelector(`[${at}="hamburger"]`).classList.remove(yt), document.querySelector(`[${at}="hamburger"]`).closest(dt).classList.remove(mt));
                            }
                            hideDrawer() {
                                this.buttons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                    this.drawer.classList.remove(yt),
                                    this.drawerScrolls && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                    document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 })),
                                    nt(),
                                    setTimeout(() => {
                                        this.drawer.classList.contains(yt) || this.drawer.classList.add(ft);
                                    }, 800),
                                    "hamburger" === this.key && this.outer.classList.remove(mt);
                            }
                            closeDrawerOnLargeScreens() {
                                document.addEventListener("theme:resize:width", () => {
                                    !this.outer.classList.contains(gt) && this.outer.classList.contains(mt) && this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !1 }));
                                });
                            }
                            constructor(t) {
                                (this.drawer = t), (this.drawerScrolls = this.drawer.querySelector(lt)), (this.underlay = this.drawer.querySelector(ct)), (this.key = this.drawer.dataset.drawer);
                                const e = `[${ut}='${this.key}']`;
                                (this.buttons = document.querySelectorAll(e)),
                                    (this.staggers = this.drawer.querySelectorAll(ht)),
                                    (this.outer = this.drawer.closest(dt)),
                                    this.connectToggle(),
                                    this.connectDrawer(),
                                    this.closers(),
                                    this.staggerChildAnimations(),
                                    this.closeDrawerOnLargeScreens();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                vt[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        bt = "[data-announcement-wrapper]",
        St = "data-header-transparent",
        Et = "[data-header-wrapper] header",
        Lt = '[data-header-sticky="false"]',
        kt = "js__header__stuck",
        Tt = "js__header__stuck--animated",
        At = "js__header__stuck--trigger-animation",
        qt = "js__header__stuck__backdrop",
        xt = "is-not-visible",
        Ct = "has-sticky-header";
    let Pt = {};
    const $t = {
            onLoad() {
                Pt = new (class {
                    unload() {
                        (this.sticks || this.animated) && document.removeEventListener("theme:scroll", this.scrollEventListen),
                            this.animated && (document.removeEventListener("theme:scroll:up", this.scrollEventUpListen), document.removeEventListener("theme:scroll:down", this.scrollEventDownListen)),
                            this.static && document.removeEventListener("theme:scroll", this.scrollEventStatic);
                    }
                    listen() {
                        (this.sticks || this.animated) && document.addEventListener("theme:scroll", this.scrollEventListen),
                            this.animated && (document.addEventListener("theme:scroll:up", this.scrollEventUpListen), document.addEventListener("theme:scroll:down", this.scrollEventDownListen));
                    }
                    listenScroll(t) {
                        t.detail.down
                            ? (!this.currentlyStuck && t.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && t.detail.position > this.blur && this.addBlur())
                            : (t.detail.position <= this.stickUp && this.unstickSimple(), t.detail.position <= this.blur && this.removeBlur());
                    }
                    stickSimple() {
                        this.animated && this.cls.add(Tt), this.cls.add(kt), this.wrapper.setAttribute(St, !1), (this.currentlyStuck = !0);
                    }
                    unstickSimple() {
                        document.documentElement.hasAttribute("data-scroll-locked") || (this.cls.remove(kt), this.wrapper.setAttribute(St, theme.transparentHeader), this.animated && this.cls.remove(Tt), (this.currentlyStuck = !1));
                    }
                    scrollDownInit() {
                        window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur();
                    }
                    stickDirectional() {
                        this.cls.add(At);
                    }
                    unstickDirectional() {
                        this.cls.remove(At);
                    }
                    scrollDownDirectional() {
                        this.unstickDirectional();
                    }
                    scrollUpDirectional() {
                        window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional();
                    }
                    addBlur() {
                        this.cls.add(qt), (this.currentlyBlurred = !0);
                    }
                    removeBlur() {
                        this.cls.remove(qt), (this.currentlyBlurred = !1);
                    }
                    checkIsVisible() {
                        const t = document.querySelector(Lt),
                            e = this.win.pageYOffset;
                        t && t.classList.toggle(xt, e >= this.headerHeight);
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.type = this.wrapper.dataset.headerSticky),
                            (this.sticks = "true" === this.type),
                            (this.static = "false" === this.type),
                            (this.win = window),
                            (this.animated = "directional" === this.type),
                            (this.currentlyStuck = !1),
                            (this.cls = this.wrapper.classList);
                        const e = document.querySelector(bt),
                            i = e ? e.clientHeight : 0;
                        (this.headerHeight = document.querySelector(Et).clientHeight),
                            (this.blur = this.headerHeight + i),
                            (this.stickDown = this.headerHeight + i),
                            (this.stickUp = i),
                            (this.scrollEventStatic = () => this.checkIsVisible()),
                            (this.scrollEventListen = (t) => this.listenScroll(t)),
                            (this.scrollEventUpListen = () => this.scrollUpDirectional()),
                            (this.scrollEventDownListen = () => this.scrollDownDirectional()),
                            "false" !== this.wrapper.getAttribute(St) && (this.blur = i),
                            this.sticks ? ((this.stickDown = i), this.scrollDownInit(), document.body.classList.add(Ct)) : document.body.classList.remove(Ct),
                            this.static && document.addEventListener("theme:scroll", this.scrollEventStatic),
                            this.listen();
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof Pt.unload && Pt.unload();
            },
        },
        _t = "data-hover-disclosure-toggle",
        Dt = "[data-hover-disclosure]",
        It = "[data-top-link]",
        Mt = "[data-header-wrapper]",
        Ht = "[data-stagger]",
        Ft = "[data-stagger-first]",
        Bt = "[data-stagger-second]",
        Wt = "is-visible",
        Ot = "meganav--visible",
        Nt = "meganav--is-transitioning";
    let zt = {},
        Vt = {};
    const Rt = {
            onLoad() {
                (zt[this.id] = []),
                    (Vt = this.container.querySelectorAll(Dt)),
                    Vt.forEach((t) => {
                        zt[this.id].push(
                            new (class {
                                onBlockSelect(t) {
                                    this.disclosure.contains(t.target) && this.showDisclosure(t);
                                }
                                onBlockDeselect(t) {
                                    this.disclosure.contains(t.target) && this.hideDisclosure();
                                }
                                showDisclosure(t) {
                                    t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(Nt),
                                        this.grandparent ? this.wrapper.classList.add(Ot) : this.wrapper.classList.remove(Ot),
                                        this.trigger.setAttribute("aria-expanded", !0),
                                        this.trigger.classList.add(Wt),
                                        this.disclosure.classList.add(Wt),
                                        this.transitionTimeout && clearTimeout(this.transitionTimeout),
                                        (this.transitionTimeout = setTimeout(() => {
                                            this.wrapper.classList.remove(Nt);
                                        }, 200));
                                }
                                hideDisclosure() {
                                    this.disclosure.classList.remove(Wt), this.trigger.classList.remove(Wt), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(Ot, Nt);
                                }
                                staggerChildAnimations() {
                                    this.disclosure.querySelectorAll(Ht).forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    }),
                                        this.disclosure.querySelectorAll(Ft).forEach((t, e) => {
                                            const i = 150 * e;
                                            (t.style.transitionDelay = `${i}ms`),
                                                t.parentElement.querySelectorAll(Bt).forEach((t, e) => {
                                                    const s = 20 * (e + 1);
                                                    t.style.transitionDelay = `${i + s}ms`;
                                                });
                                        });
                                }
                                handleTablets() {
                                    this.trigger.addEventListener(
                                        "touchstart",
                                        function (t) {
                                            this.disclosure.classList.contains(Wt) || (t.preventDefault(), this.showDisclosure(t));
                                        }.bind(this),
                                        { passive: !0 }
                                    );
                                }
                                connectHoverToggle() {
                                    this.trigger.addEventListener("mouseenter", (t) => this.showDisclosure(t)),
                                        this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
                                        this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                        this.trigger.addEventListener("focusout", (t) => {
                                            this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                        }),
                                        this.disclosure.addEventListener("keyup", (t) => {
                                            t.which === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                        });
                                }
                                constructor(t) {
                                    (this.disclosure = t),
                                        (this.wrapper = t.closest(Mt)),
                                        (this.key = this.disclosure.id),
                                        (this.trigger = document.querySelector(`[${_t}='${this.key}']`)),
                                        (this.link = this.trigger.querySelector(It)),
                                        (this.grandparent = this.trigger.classList.contains("grandparent")),
                                        (this.transitionTimeout = 0),
                                        this.trigger.setAttribute("aria-haspopup", !0),
                                        this.trigger.setAttribute("aria-expanded", !1),
                                        this.trigger.setAttribute("aria-controls", this.key),
                                        this.connectHoverToggle(),
                                        this.handleTablets(),
                                        this.staggerChildAnimations();
                                }
                            })(t)
                        );
                    });
            },
            onBlockSelect(t) {
                zt[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                zt[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        jt = "data-cart-count";
    const Ut = {
        onLoad() {
            new (class {
                listen() {
                    document.addEventListener(
                        "theme:cart:change",
                        function (t) {
                            (this.cart = t.detail.cart), this.update();
                        }.bind(this)
                    );
                }
                update() {
                    this.cart &&
                        this.counts.forEach((t) => {
                            t.setAttribute(jt, this.cart.item_count), (t.innerHTML = `${this.cart.item_count}`);
                        });
                }
                constructor(t) {
                    (this.section = t), (this.counts = this.section.querySelectorAll(`[${jt}]`)), (this.cart = null), this.listen();
                }
            })(this.container);
        },
    };
    function Jt(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    Jt.prototype = Error.prototype;
    const Yt = (t, e = 500, i = !0) => {
            let s = window.getComputedStyle(t).display;
            if (i && "none" !== s) return;
            t.style.removeProperty("display"), "none" === s && (s = "block"), (t.style.display = s);
            let o = t.offsetHeight;
            t.classList.add("is-transitioning"),
                (t.style.overflow = "hidden"),
                (t.style.height = 0),
                (t.style.paddingTop = 0),
                (t.style.paddingBottom = 0),
                (t.style.marginTop = 0),
                (t.style.marginBottom = 0),
                t.offsetHeight,
                (t.style.boxSizing = "border-box"),
                (t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (t.style.transitionProperty = "height, margin, padding"),
                (t.style.transitionDuration = e + "ms"),
                (t.style.height = o + "px"),
                t.style.removeProperty("padding-top"),
                t.style.removeProperty("padding-bottom"),
                t.style.removeProperty("margin-top"),
                t.style.removeProperty("margin-bottom"),
                window.setTimeout(() => {
                    t.style.removeProperty("height"),
                        t.style.removeProperty("overflow"),
                        t.style.removeProperty("transition-duration"),
                        t.style.removeProperty("transition-property"),
                        t.style.removeProperty("transition-timing-function"),
                        t.classList.remove("is-transitioning");
                }, e);
        },
        Kt = (t, e = 500) => {
            t.classList.add("is-transitioning"),
                (t.style.transitionProperty = "height, margin, padding"),
                (t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (t.style.transitionDuration = e + "ms"),
                (t.style.boxSizing = "border-box"),
                (t.style.height = t.offsetHeight + "px"),
                t.offsetHeight,
                (t.style.overflow = "hidden"),
                (t.style.height = 0),
                (t.style.paddingTop = 0),
                (t.style.paddingBottom = 0),
                (t.style.marginTop = 0),
                (t.style.marginBottom = 0),
                window.setTimeout(() => {
                    (t.style.display = "none"),
                        t.style.removeProperty("height"),
                        t.style.removeProperty("padding-top"),
                        t.style.removeProperty("padding-bottom"),
                        t.style.removeProperty("margin-top"),
                        t.style.removeProperty("margin-bottom"),
                        t.style.removeProperty("overflow"),
                        t.style.removeProperty("transition-duration"),
                        t.style.removeProperty("transition-property"),
                        t.style.removeProperty("transition-timing-function"),
                        t.classList.remove("is-transitioning");
                }, e);
        },
        Xt = "[data-cart-note]";
    class Qt {
        initInputs() {
            this.inputs.forEach((t) => {
                t.addEventListener(
                    "input",
                    u(
                        function (t) {
                            const e = t.target.value.toString() || "";
                            this.saveNotes(e);
                        }.bind(this),
                        300
                    )
                );
            });
        }
        saveNotes(t) {
            window.fetch(`${window.theme.routes.cart}/update.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: t }) }).catch((t) => {
                console.error(t);
            });
        }
        constructor(t) {
            (this.inputs = t.querySelectorAll(Xt)), this.initInputs();
        }
    }
    const Gt = (t, e = [], i = !1) => {
            const s = Object.keys(t)
                .map((s) => {
                    let o = t[s];
                    if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(s), Gt(o, e, Array.isArray(o));
                    {
                        let t = s;
                        if (e.length > 0) {
                            t = (i ? e : [...e, s]).reduce((t, e) => ("" === t ? e : `${t}[${e}]`), "");
                        }
                        return i ? `${t}[]=${o}` : `${t}=${o}`;
                    }
                })
                .join("&");
            return e.pop(), s;
        },
        Zt = "[data-submit-shipping]",
        te = "[data-shipping-estimate-form]",
        ee = "[data-response-template]",
        ie = "#estimate_address_country",
        se = "#estimate_address_province",
        oe = "#estimate_address_zip",
        ne = "[data-response-wrapper]",
        re = "data-default-fullname",
        ae = "shipping--success",
        le = "errors";
    class ce {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove("disabled");
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add("disabled");
        }
        render(t) {
            if (this.template && this.ratesWrapper) {
                const e = d.render(this.template, t);
                this.ratesWrapper.innerHTML = e;
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
        }
        estimate(t) {
            const e = encodeURI(Gt({ shipping_address: t })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${e}`,
                s = this;
            n.get(i)
                .then(function (t) {
                    const e = s.sanitize(t);
                    s.render(e), s.enableButtons(), s.ratesWrapper.style.removeProperty("display");
                })
                .catch(function (t) {
                    const e = s.sanitizeErrors(t);
                    s.render(e);
                });
        }
        sanitize(t) {
            const e = {};
            if (((e.class = ae), (e.items = []), t.data.shipping_rates && t.data.shipping_rates.length > 0)) {
                t.data.shipping_rates.forEach((t) => {
                    let s = {};
                    (s.title = t.presentment_name), (s.value = i.formatMoney(t.price, theme.moneyFormat)), e.items.push(s);
                });
            } else e.items[0] = { value: theme.strings.noShippingAvailable };
            return e;
        }
        sanitizeErrors(t) {
            const e = {};
            if (((e.class = le), (e.items = []), "object" == typeof t.data))
                for (const [i, s] of Object.entries(t.data)) {
                    let t = {};
                    (t.title = i.toString()), (t.value = s.toString()), e.items.push(t);
                }
            else e.items[0] = { value: theme.strings.noShippingAvailable };
            return e;
        }
        init() {
            const t = document.querySelector("html");
            let e = "en";
            t.hasAttribute("lang") && "" !== t.getAttribute("lang") && (e = t.getAttribute("lang")),
                this.form && s.AddressForm(this.form, e, { shippingCountriesOnly: !0 }),
                this.country &&
                    this.country.hasAttribute("data-default") &&
                    this.province &&
                    this.province.hasAttribute("data-default") &&
                    this.country.addEventListener("change", function () {
                        this.country.removeAttribute("data-default"), this.province.removeAttribute("data-default");
                    }),
                this.button &&
                    this.button.addEventListener(
                        "click",
                        function (t) {
                            for (t.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild; ) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                            this.ratesWrapper.style.display = "none";
                            const e = {};
                            let i = this.country.value,
                                s = this.province.value;
                            const o = this.country.getAttribute(re);
                            "" === i && o && "" !== o && (i = o);
                            const n = this.province.getAttribute(re);
                            "" === s && n && "" !== n && (s = n), (e.zip = this.zip.value || ""), (e.country = i || ""), (e.province = s || ""), this.estimate(e);
                        }.bind(this)
                    );
        }
        constructor(t) {
            (this.button = t.container.querySelector(Zt)),
                (this.template = t.container.querySelector(ee).innerHTML),
                (this.ratesWrapper = t.container.querySelector(ne)),
                (this.form = t.container.querySelector(te)),
                (this.country = t.container.querySelector(ie)),
                (this.province = t.container.querySelector(se)),
                (this.zip = t.container.querySelector(oe)),
                this.init();
        }
    }
    const he = "[data-cart-message]",
        de = "data-cart-message",
        ue = "[data-left-to-spend]",
        pe = "[data-cart-progress]",
        me = "is-hidden",
        ye = "is-success";
    const fe = "[data-custom-scrollbar-items]",
        ge = "[data-custom-scrollbar]",
        ve = "[data-custom-scrollbar-track]",
        we = "hide",
        be = {};
    let Se = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)),
                document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)),
                document.addEventListener("theme:resize:width", this.calculatePosition.bind(this));
        }
        calculateTrackWidth() {
            (this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth),
                setTimeout(() => {
                    (this.scrollWidth =
                        this.holderItems.children.length *
                        (this.holderItems.children[0].clientWidth +
                            Number(getComputedStyle(this.holderItems.children[0]).marginRight.replace("px", "")) +
                            Number(getComputedStyle(this.holderItems.children[0]).marginLeft.replace("px", "")))),
                        (this.trackWidth = (this.scrollbarWidth / this.scrollWidth) * 100),
                        (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                        this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                    const t = this.trackWidth >= 100;
                    this.scrollbar.classList.toggle(we, t);
                }, 100);
        }
        calculatePosition() {
            let t = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            (t *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
                (t = t < 0 ? 0 : t),
                (t = isNaN(t) ? 0 : t),
                this.scrollbar.style.setProperty("--position", `${Math.round(t)}px`),
                document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", { bubbles: !0, detail: { holder: this.holderItems } }));
        }
        constructor(t) {
            (this.holderItems = t.querySelector(fe)),
                (this.scrollbar = t.querySelector(ge)),
                (this.scrollbarTrack = t.querySelector(ve)),
                (this.trackWidth = 0),
                (this.scrollWidth = 0),
                this.scrollbar && this.holderItems && (this.events(), this.calculateTrackWidth());
        }
    };
    const Ee = {
        onLoad() {
            be[this.id] = new Se(this.container);
        },
    };
    var Le = !1;
    function ke() {
        return Le;
    }
    document.addEventListener(
        "touchstart",
        function t() {
            (Le = !0), document.removeEventListener("touchstart", t, { passive: !0 }), document.querySelector("body").classList.add("supports-touch"), document.dispatchEvent(new CustomEvent("theme:touch", { bubbles: !0 }));
        },
        { passive: !0 }
    );
    var Te = {},
        Ae = {},
        qe = {};
    const xe = "[data-product-slideshow]",
        Ce = "[data-shopify-xr]",
        Pe = "data-media-id",
        $e = "data-model-id",
        _e = "model-viewer",
        De = "data-shopify-model3d-id",
        Ie = "#ModelJson-";
    function Me(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
            for (const t in Te)
                if (Te.hasOwnProperty(t)) {
                    const e = Te[t];
                    if (e.loaded) continue;
                    const i = document.querySelector(`${Ie}${t}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), (e.loaded = !0));
                }
            window.ShopifyXR.setupXRElements();
        } else
            document.addEventListener("shopify_xr_initialized", function () {
                Me();
            });
    }
    function He(t) {
        if (t) console.warn(t);
        else
            for (const t in Ae)
                if (Ae.hasOwnProperty(t)) {
                    const e = Ae[t];
                    e.modelViewerUi || (e.modelViewerUi = new Shopify.ModelViewerUI(e.$element)), Fe(e);
                }
    }
    function Fe(t) {
        const e = qe[t.sectionId];
        t.$container.addEventListener("pause", function () {
            t.modelViewerUi.pause && t.modelViewerUi.pause();
        }),
            t.$container.addEventListener("play-desktop", function () {
                t.modelViewerUi.play && !ke() && t.modelViewerUi.play(), e && e.$element && t && t.modelId && De && e.$element.setAttribute(De, t.modelId);
            }),
            t.$container.addEventListener("play", function () {
                t.modelViewerUi.play && t.modelViewerUi.play();
            }),
            t.$container.addEventListener("click", function () {
                e && e.$element && t && t.modelId && De && e.$element.setAttribute(De, t.modelId);
            }),
            document.addEventListener("theme:scrollbar:scroll", function (e) {
                e.detail.holder === t.$container.parentElement &&
                    (function (t) {
                        const e = qe[t.sectionId];
                        new IntersectionObserver(
                            (t, i) => {
                                t.forEach((t) => {
                                    const i = t.intersectionRatio > 0.5;
                                    t.target.hasAttribute(Pe) && i && e.$element.setAttribute(De, t.target.getAttribute(Pe));
                                });
                            },
                            { threshold: 1 }
                        ).observe(t.$container);
                    })(t);
            });
    }
    function Be(t, e, i) {
        let s = document.getElementsByTagName("head")[0],
            o = !1,
            n = document.createElement("script");
        (n.src = t),
            (n.onload = n.onreadystatechange = function () {
                o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? i() : ((o = !0), e());
            }),
            s.appendChild(n);
    }
    const We = {};
    function Oe(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return We[t.url]
                ? We[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : Be(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (We[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return We[t.json]
                ? Promise.resolve(We[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((We[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return We[e]
                ? We[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (We[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    async function Ne(t) {
        const e = document.querySelector(`[data-player="${t}"]`),
            i = e.querySelector("video");
        await Oe({ name: "video-ui", version: "1.0" });
        const s = new window.Shopify.Plyr(i);
        return (
            e.addEventListener("pause", function () {
                s.pause && s.pause();
            }),
            e.addEventListener("play-desktop", function () {
                s.play && !ke() && e.dispatchEvent(new CustomEvent("play"));
            }),
            e.addEventListener("play", function () {
                try {
                    s.play
                        ? s.play()
                        : s.addEventListener("onReady", function (t) {
                              t.target.play();
                          });
                } catch (t) {
                    console.warn(t);
                }
            }),
            e.addEventListener("destroy", function () {
                try {
                    s.destroy && s.destroy();
                } catch (t) {
                    console.warn(t);
                }
            }),
            s
        );
    }
    window.isYoutubeAPILoaded = !1;
    const ze = { autoplay: !0, loop: !0, controls: !0, muted: !1, playsinline: !0 };
    function Ve(t, e) {
        const i = { ...ze, ...e },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector("iframe, [data-replace]"),
            n = s.querySelector("[data-video-id]").getAttribute("data-video-id"),
            r = Oe({ url: "https://player.vimeo.com/api/player.js" }),
            a = `select-${t}`;
        o.setAttribute("id", a);
        return r
            .then(function () {
                const t = new window.Vimeo.Player(a, { ...i, id: n });
                return (
                    s.addEventListener("pause", function () {
                        try {
                            t.pause && t.pause();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("play-desktop", function () {
                        ke() || s.dispatchEvent(new Event("play"));
                    }),
                    s.addEventListener("play", function () {
                        t.play && t.play();
                    }),
                    s.addEventListener("destroy", function () {
                        try {
                            t.destroy && t.destroy();
                        } catch (t) {
                            console.log(t);
                        }
                    }),
                    t
                );
            })
            .catch(function (t) {
                console.error(t);
            });
    }
    const Re = {
            productSlideshow: "[data-product-slideshow]",
            productThumbs: "[data-product-thumbs]",
            thumbImage: "[data-slideshow-thumbnail]",
            mediaSlide: "[data-media-slide]",
            mediaId: "data-media-id",
            mediaSelect: "data-media-select",
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            allPlayers: "[data-player]",
            videoYT: "[data-video-youtube]",
            videoVimeo: "[data-video-vimeo]",
            flickitylockHeight: "flickity-lock-height",
            flickityDisableClass: "flickity-disabled-mobile",
            hideClass: "hide",
        },
        je = "data-type",
        Ue = "data-tall-layout",
        Je = "data-enable-video-looping",
        Ye = "data-thumbs-align",
        Ke = "data-upsell-product",
        Xe = "data-options";
    let Qe = class {
            init() {
                this.createSlider(),
                    this.detectVideo(),
                    this.detectVimeo(),
                    this.detect3d(),
                    this.stopSlider(),
                    document.addEventListener("theme:resize", () => {
                        this.stopSlider();
                    });
            }
            createSlider() {
                if (!this.slideshow || this.tallLayout) return;
                const t = this;
                let i = null;
                this.slideshow.hasAttribute(Xe) && (i = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(Xe)))),
                    i ||
                        (i = {
                            autoPlay: !1,
                            prevNextButtons: !1,
                            contain: !0,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            wrapAround: !0,
                            fade: !0,
                            watchCSS: !0,
                            on: {
                                ready: function () {
                                    t.isUpsell || t.sliderThumbs();
                                },
                            },
                        }),
                    (this.flkty = new e(this.slideshow, i)),
                    this.flkty.resize(),
                    (this.currentSlide = this.slideshow.querySelectorAll(Re.mediaSlide)[0]),
                    this.setDraggable(),
                    this.flkty.on(
                        "change",
                        function (t) {
                            var e;
                            this.currentSlide.dispatchEvent(new CustomEvent("pause")), (this.currentSlide = this.flkty.cells[t].element), this.slideshow.classList.remove(Re.flickitylockHeight);
                            const i = this.currentSlide.getAttribute(Re.mediaId),
                                s = null === (e = this.thumbWrapper) || void 0 === e ? void 0 : e.querySelector(`[${Re.mediaSelect}="${i}"]`);
                            setTimeout(() => {
                                (null == s ? void 0 : s.classList.contains(Re.hideClass)) &&
                                    (this.lastMediaSelect ? this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: this.lastMediaSelect } })) : window.location.reload());
                            });
                        }.bind(this)
                    ),
                    this.flkty.on(
                        "settle",
                        function (t) {
                            this.currentSlide = this.flkty.cells[t].element;
                            const e = this.currentSlide.querySelector(Re.videoYT);
                            e && !this.currentSlide.querySelector("iframe") && e.dispatchEvent(new Event("click")), this.setDraggable(), this.currentSlide.dispatchEvent(new CustomEvent("play-desktop"));
                            document.body.classList.contains(Re.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")), this.confirmSync();
                        }.bind(this)
                    ),
                    this.eventListeners();
            }
            stopSlider() {
                var t;
                window.innerWidth < window.theme.sizes.medium && (null === (t = this.slideshow) || void 0 === t ? void 0 : t.classList.contains(Re.flickityDisableClass)) && new Se(this.container);
            }
            eventListeners() {
                this.slideshow.addEventListener(
                    "theme:image:change",
                    function (t) {
                        const e = t.detail.id;
                        this.lastMediaSelect = e;
                        const i = `[${Re.mediaId}="${e}"]`;
                        if (window.innerWidth >= window.theme.sizes.medium || this.isUpsell) {
                            const t = (t) => t.element.matches(i),
                                e = this.flkty.cells.findIndex(t);
                            this.flkty.select(e);
                        } else {
                            const t = this.slideshow.querySelector(i);
                            this.slideshow.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
                        }
                    }.bind(this)
                ),
                    this.thumbImages.forEach((t) => {
                        t.addEventListener(
                            "click",
                            function (t) {
                                const e = t.currentTarget.getAttribute(Re.mediaSelect);
                                this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: e } }));
                            }.bind(this)
                        );
                    });
            }
            sliderThumbs() {
                let t = { freeScroll: !0, contain: !0, prevNextButtons: !1, pageDots: !1, accessibility: !0, watchCSS: !0, cellAlign: this.centerAlign ? "center" : "left", sync: this.slideshow };
                this.flktyThumbs = new a(this.thumbWrapper, t);
            }
            confirmSync() {
                this.flktyThumbs && this.flkty.selectedIndex !== this.flktyThumbs.selectedIndex && this.flkty.resize();
            }
            setDraggable() {
                if (this.currentSlide) {
                    const t = this.currentSlide.getAttribute(je);
                    "model" === t || "video" === t || "external_video" === t ? ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()) : ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                }
            }
            detect3d() {
                const t = this.container.querySelectorAll(Re.modelViewer);
                t &&
                    (t.forEach((t) => {
                        !(function (t, e) {
                            Te[e] = { loaded: !1 };
                            const i = t.getAttribute(Pe),
                                s = t.querySelector(_e),
                                o = s.getAttribute($e),
                                n = t.closest(xe).parentElement.querySelector(Ce);
                            (qe[e] = { $element: n, defaultId: o }),
                                (Ae[i] = { modelId: o, mediaId: i, sectionId: e, $container: t, $element: s }),
                                window.Shopify.loadFeatures([
                                    { name: "shopify-xr", version: "1.0", onLoad: Me },
                                    { name: "model-viewer-ui", version: "1.0", onLoad: He },
                                ]);
                        })(t, this.section.id);
                    }),
                    document.addEventListener(
                        "shopify_xr_launch",
                        function () {
                            this.container.querySelectorAll(Re.allPlayers).forEach((t) => {
                                t.dispatchEvent(new CustomEvent("pause"));
                            });
                        }.bind(this)
                    ));
            }
            detectVideo() {
                const t = this.container.querySelectorAll(Re.videoPlayerNative);
                for (var e of t) {
                    const t = Ne(e.dataset.player);
                    !0 === this.loopVideo &&
                        t
                            .then((t) => ((t.loop = !0), t))
                            .catch((t) => {
                                console.error(t);
                            });
                }
            }
            detectVimeo() {
                const t = this.container.querySelectorAll(Re.videoVimeo);
                if (t.length)
                    for (const e of t) {
                        const t = Ve(e.dataset.player, { loop: this.loopVideo });
                        this.loopVideo &&
                            t
                                .then((t) => t.setLoop(!0))
                                .catch((t) => {
                                    console.error(t);
                                });
                    }
            }
            pauseAllMedia() {
                this.container.querySelector("[data-media-slide]").dispatchEvent(new CustomEvent("pause"));
            }
            pauseOtherMedia(t) {
                this.container.querySelector(`[data-media-slide]:not([data-player="${t}"])`).dispatchEvent(new CustomEvent("pause"));
            }
            destroy() {
                this.container.querySelectorAll(Re.allPlayers).forEach((t) => {
                    t.dispatchEvent(new CustomEvent("destroy"));
                });
            }
            constructor(t) {
                var e;
                (this.section = t),
                    (this.container = t.container || t),
                    (this.slideshow = this.container.querySelector(Re.productSlideshow)),
                    (this.tallLayout = "true" === this.container.getAttribute(Ue)),
                    (this.thumbWrapper = this.container.querySelector(Re.productThumbs)),
                    (this.thumbImages = this.container.querySelectorAll(Re.thumbImage)),
                    (this.loopVideo = "true" === this.container.getAttribute(Je)),
                    (this.centerAlign = "center" === this.container.getAttribute(Ye)),
                    (this.isUpsell = null === (e = this.slideshow) || void 0 === e ? void 0 : e.parentElement.hasAttribute(Ke)),
                    (this.flkty = null),
                    (this.lastMediaSelect = null),
                    (this.flktyThumbs = null),
                    (this.currentSlide = null),
                    this.init();
            }
        },
        Ge = {};
    const Ze = "[data-add-action-wrapper]",
        ti = "[data-add-to-cart]",
        ei = "[data-add-action-errors]",
        ii = "data-add-to-cart-variant",
        si = '[data-drawer="drawer-cart"]',
        oi = "[data-ajax-disable]",
        ni = "[data-upsell-modal]",
        ri = "loading",
        ai = "has-success",
        li = "id";
    let ci = class {
        initWithForm() {
            this.button.addEventListener(
                "click",
                function (t) {
                    const e = t.target.closest("form");
                    if (e.querySelector('[type="file"]')) return;
                    this.reloadCart || t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(ri);
                    const i = new FormData(e),
                        s = new URLSearchParams(i).toString();
                    this.addToCartAction(s);
                }.bind(this)
            );
        }
        initDetached() {
            this.button.addEventListener(
                "click",
                function (t) {
                    t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(ri);
                    const e = `form_type=product&id=${this.button.getAttribute(ii)}`;
                    this.addToCartAction(e);
                }.bind(this)
            );
        }
        addToCartAction(t) {
            const e = `${window.theme.routes.cart}/add.js`,
                i = this;
            n.post(e, t, { headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/x-www-form-urlencoded" } })
                .then(function (t) {
                    i.onSuccess(t.data);
                })
                .catch(function (t) {
                    console.warn(t), i.onError(t.data);
                });
        }
        onSuccess(t) {
            this.updateHeaderTotal(),
                this.button.classList.remove(ri),
                this.button.classList.add(ai),
                setTimeout(() => {
                    this.button.classList.remove(ai), this.button.removeAttribute("disabled");
                }, 3500),
                this.reloadCart
                    ? document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }))
                    : this.drawer && this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { detail: { variant: t, reinit: !0 }, bubbles: !0 }));
            const e = document.querySelector(ni);
            if (e) {
                const t = e.getAttribute(li);
                r.close(t), e.setAttribute("aria-hidden", !0);
            }
        }
        onError(t) {
            if (!t) throw t;
            {
                t.description && "string" == typeof t.description
                    ? (this.error = t.description)
                    : t.message && "string" == typeof t.message
                    ? (this.error = t.message)
                    : t.description && "object" == typeof t.description
                    ? (this.error = Object.keys(t.description)
                          .map((e) => `${e}: ${t.description[e]}`)
                          .join("<br>"))
                    : (this.error = "Network error: please try again");
                const e = `<div class="errors">${this.error}</div>`;
                this.button.classList.remove(ri),
                    this.button.removeAttribute("disabled"),
                    (this.errors.innerHTML = e),
                    Yt(this.errors),
                    setTimeout(() => {
                        Kt(this.errors);
                    }, 5e3);
            }
        }
        updateHeaderTotal() {
            n.get(`${window.theme.routes.cart}.js`)
                .then((t) => {
                    document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t.data }, bubbles: !0 }));
                })
                .catch((t) => {
                    console.error(t);
                });
        }
        constructor(t, e = !1) {
            if (
                ((this.wrapper = t),
                (this.button = t.querySelector(ti)),
                (this.errors = t.querySelector(ei)),
                (this.drawer = document.querySelector(si)),
                (this.reloadCart = e),
                document.querySelector(oi) && (this.reloadCart = !0),
                this.button)
            ) {
                this.button.hasAttribute(ii) ? this.initDetached() : this.initWithForm();
            }
        }
    };
    const hi = {
            onLoad() {
                Ge[this.id] = [];
                this.container.querySelectorAll(Ze).forEach((t) => {
                    Ge[this.id].push(new ci(t));
                });
            },
            onUnload: function () {
                Ge[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        di = "data-upsell-holder",
        ui = "[data-add-action-wrapper]",
        pi = "[data-upsell-modal]",
        mi = "[data-upsell-modal-product]",
        yi = "[data-upsell-modal-close-handle]",
        fi = "[data-product-upsell-ajax]",
        gi = "[data-upsell-modal-template]",
        vi = "[data-line-items]",
        wi = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
    let bi = class extends HTMLElement {
        init() {
            this.modalTemplate &&
                this.triggerButton &&
                this.triggerButton.addEventListener("click", (t) => {
                    t.preventDefault(), this.modal && this.modalID && (this.modal.id = this.modalID), this.getUpsellHTML();
                }),
                this.isCartItem && new ci(this.upsellHolder, this.isCartItem);
        }
        getUpsellHTML() {
            window
                .fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-upsell`)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    (e.innerHTML = t), (this.modalContent = document.querySelector(fi)), (this.modalContent.innerHTML = e.querySelector("[data-api-content]").innerHTML), this.modalCreate();
                });
        }
        modalCreate() {
            r.show(this.modalID, {
                onShow: (t, e, i) => {
                    const s = t.querySelector(ui);
                    new Qe(t), new ci(s, this.isCartItem);
                    const o = t.querySelector(wi);
                    ot(t, { elementToFocus: o }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                },
                onClose: (t, e, i) => {
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })), nt(), e.focus();
                },
            }),
                this.modalAnimation();
        }
        modalAnimation() {
            const t = this.modal.querySelector(yi),
                e = this.modal.querySelector(mi);
            t.addEventListener("touchstart", this.touchHandler.bind(this, e, t));
        }
        touchHandler(t, e, i) {
            const s = i.changedTouches[0].screenY;
            let o = 0;
            const n = (e) => {
                    (o = e.changedTouches[0].screenY - s), o > 0 && (t.style.transform = `translateY(${o}px)`);
                },
                a = () => {
                    o > 20 && ((t.style.transform = ""), r.close(this.modalID)), e.removeEventListener("touchmove", n), e.removeEventListener("touchend", a), e.removeEventListener("touchstart", this.touchHandler.bind(this, t, e));
                };
            e.addEventListener("touchmove", n), e.addEventListener("touchend", a);
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Jt({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        constructor() {
            if ((super(), (this.upsellHolder = this.querySelector(`[${di}]`)), this.upsellHolder)) {
                if (
                    ((this.isCartItem = Boolean(this.upsellHolder.closest(vi))),
                    (this.modalTemplate = this.upsellHolder.querySelector(gi)),
                    (this.modal = document.querySelector(pi)),
                    (this.modalID = this.upsellHolder.getAttribute(di)),
                    (this.triggerButton = this.upsellHolder.querySelector(`[data-popup-${this.modalID}]`)),
                    (this.handle = this.triggerButton ? this.triggerButton.getAttribute(`data-popup-${this.modalID}`) : null),
                    (this.modalContent = null),
                    this.modalTemplate && !this.modal)
                ) {
                    const t = this.modalTemplate.innerHTML,
                        e = document.createElement("div");
                    e.innerHTML = t;
                    const i = e.querySelector(pi);
                    document.body.appendChild(i), (this.modal = document.querySelector(pi));
                }
                this.init();
            }
        }
    };
    const Si = "[data-quantity-selector]",
        Ei = "[data-increase-quantity]",
        Li = "[data-decrease-quantity]",
        ki = "[data-quantity-input]";
    function Ti(t) {
        t.querySelectorAll(Si).forEach((t) => {
            new (class {
                initButtons() {
                    this.increase.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault();
                            let e = parseInt(this.input.value, 10);
                            (e = isNaN(e) ? 0 : e), e++, (this.input.value = e), this.input.dispatchEvent(new Event("change"));
                        }.bind(this)
                    ),
                        this.decrease.addEventListener(
                            "click",
                            function (t) {
                                t.preventDefault();
                                let e = parseInt(this.input.value, 10);
                                (e = isNaN(e) ? 0 : e), e--, (e = Math.max(this.min, e)), (this.input.value = e), this.input.dispatchEvent(new Event("change"));
                            }.bind(this)
                        );
                }
                constructor(t) {
                    (this.wrapper = t),
                        (this.increase = this.wrapper.querySelector(Ei)),
                        (this.decrease = this.wrapper.querySelector(Li)),
                        (this.input = this.wrapper.querySelector(ki)),
                        (this.min = parseInt(this.input.getAttribute("min"), 10)),
                        this.initButtons();
                }
            })(t);
        });
    }
    const Ai = '[data-drawer="drawer-cart"]',
        qi = "[data-shipping-estimate-form]",
        xi = "[data-cart-loading]",
        Ci = "[data-cart-form]",
        Pi = "[data-cart-empty]",
        $i = "[data-cart-progress]",
        _i = "[data-line-items]",
        Di = "[data-cart-subtotal]",
        Ii = "[data-cart-bottom]",
        Mi = "[data-form-errors]",
        Hi = "[data-cart-item]",
        Fi = "[data-cart-final]",
        Bi = "data-update-cart",
        Wi = "data-remove-key",
        Oi = "[data-upsell-holder]",
        Ni = '[data-section-type="cart"]',
        zi = "[data-cart-bar]",
        Vi = "[data-cart-blankstate]",
        Ri = "cart--hidden",
        ji = "cart--loading";
    let Ui = class {
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (t) {
                    (this.cart = t.detail.cart), (this.stale = !0);
                }.bind(this)
            ),
                document.addEventListener(
                    "theme:cart:init",
                    function () {
                        this.init();
                    }.bind(this)
                ),
                document.addEventListener(
                    "theme:cart:reload",
                    function () {
                        (this.stale = !0), this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML());
                    }.bind(this)
                ),
                this.drawer &&
                    this.drawer.addEventListener(
                        "theme:drawer:open",
                        function (t) {
                            const e = null !== t.detail && t.detail.reinit;
                            this.cart && !e ? this.loadHTML() : this.init().then(() => this.loadHTML());
                        }.bind(this)
                    ),
                new Qt(this.container),
                new (class {
                    init() {
                        (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute("data-limit"))),
                            (this.cartFreeLimitShipping *= window.Shopify.currency.rate),
                            (this.shippingAmount = 0),
                            this.cartBarProgress(),
                            this.listen();
                    }
                    listen() {
                        document.addEventListener(
                            "theme:cart:change",
                            function (t) {
                                (this.cart = t.detail.cart), this.render();
                            }.bind(this)
                        );
                    }
                    render() {
                        if (this.cart && this.cart.total_price) {
                            const t = this.cart.total_price;
                            this.freeShippingMessageHandle(t), this.cartMessage.length > 0 && ((this.shippingAmount = t), this.updateProgress());
                        }
                    }
                    freeShippingMessageHandle(t) {
                        this.cartMessage.length > 0 &&
                            this.container.querySelectorAll(he).forEach((e) => {
                                const i = e.hasAttribute(de) && "true" === e.getAttribute(de) && 0 !== t ? ye : me;
                                e.classList.toggle(i, t >= this.cartFreeLimitShipping);
                            });
                    }
                    cartBarProgress(t = null) {
                        this.container.querySelectorAll(pe).forEach((e) => {
                            this.setProgress(e, null === t ? e.getAttribute("data-percent") : t);
                        });
                    }
                    setProgress(t, e) {
                        t.style.setProperty("--bar-progress", `${e}%`);
                    }
                    updateProgress() {
                        const t = (this.shippingAmount / this.cartFreeLimitShipping) * 100,
                            e = theme.settings.currency_code_enable
                                ? i.formatMoney(this.cartFreeLimitShipping - this.shippingAmount, theme.moneyFormat) + ` ${theme.currencyCode}`
                                : i.formatMoney(this.cartFreeLimitShipping - this.shippingAmount, theme.moneyFormat);
                        this.container.querySelectorAll(ue).forEach((t) => {
                            t.innerHTML = e.replace(".00", "");
                        }),
                            this.cartBarProgress(t > 100 ? 100 : t);
                    }
                    constructor(t) {
                        (this.container = t), (this.cartMessage = this.container.querySelectorAll(he)), this.cartMessage.length > 0 && this.init();
                    }
                })(this.container);
        }
        init() {
            var t;
            this.emptystate.classList.contains(Ri) || (this.emptystate.classList.add(Ri), null === (t = this.blankState) || void 0 === t || t.classList.remove(Ri));
            return window
                .fetch(`${window.theme.routes.cart}.js`)
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((t) => ((this.cart = t), this.fireChange(t), t))
                .catch((t) => {
                    console.error(t);
                });
        }
        loadHTML() {
            this.stale && (this.cart && this.cart.item_count > 0 ? this.loadForm() : this.showEmpty()), (this.stale = !1);
        }
        initInputs() {
            (this.inputs = this.container.querySelectorAll(`[${Bi}]`)),
                this.inputs.forEach((t) => {
                    const e = t.getAttribute(Bi);
                    t.addEventListener(
                        "change",
                        function (t) {
                            const i = parseInt(t.target.value, 10);
                            (this.latestClick = t.target.closest(Hi)), this.lockState(), this.updateCart(e, i);
                        }.bind(this)
                    );
                });
        }
        initRemove() {
            (this.removers = this.container.querySelectorAll(`[${Wi}]`)),
                this.removers.forEach((t) => {
                    const e = t.getAttribute(Wi);
                    t.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), (this.latestClick = t.target.closest(Hi)), this.lockState(), this.updateCart(e, 0);
                        }.bind(this)
                    );
                });
        }
        lockState() {
            (this.latestClick.querySelector(".item--loadbar").style.display = "block"), this.loader.classList.add(ji);
        }
        updateCart(t, e) {
            window
                .fetch(`${window.theme.routes.cart}/change.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: t, quantity: e }) })
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((t) => {
                    (this.cart = t), Kt(this.errors), this.fireChange(t), (this.stale = !0), this.loadHTML();
                })
                .catch((t) => {
                    if (!(t instanceof Jt)) {
                        let e = `<p>${t.message || t.description || window.theme.strings.stockout || "Could not update cart, please reload"}</p>`;
                        throw (this.showError(e), t);
                    }
                    {
                        var e, i, s;
                        let o = `<p>${
                                (null === (e = t.json) || void 0 === e ? void 0 : e.message) ||
                                t.message ||
                                (null === (i = t.json) || void 0 === i ? void 0 : i.description) ||
                                t.description ||
                                window.theme.strings.stockout ||
                                "Could not update cart, please reload"
                            }</p>`,
                            n = (null === (s = t.json) || void 0 === s ? void 0 : s.description) || "";
                        this.showError([o, n].join(" ")), this.loadForm();
                    }
                });
        }
        fireChange(t) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t }, bubbles: !0 }));
        }
        updateTotal() {
            if (this.cart && this.cart.total_price) {
                const t = i.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = t + ` ${theme.currencyCode}`;
            }
            this.subtotal &&
                this.cart &&
                window
                    .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        (e.innerHTML = t), (this.subtotal.innerHTML = e.querySelector("[data-api-content]").innerHTML);
                    });
        }
        showError(t) {
            Kt(this.errors),
                (this.errors.innerHTML = t),
                window.setTimeout(() => {
                    Yt(this.errors);
                }, 600);
        }
        stockoutError(t) {
            let e = `<p><strong>${window.theme.strings.stockout}</strong></p>`,
                i = `<p>${t}</p>`;
            this.showError(`${e + i}`);
        }
        loadForm() {
            window
                .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    (e.innerHTML = t), (this.items.innerHTML = e.querySelector("[data-api-content]").innerHTML), this.showForm(), this.initQuantity(), this.initUpsell(), this.updateTotal(), this.drawer && L(this.drawer);
                });
        }
        initUpsell() {
            const t = this.items.querySelector(Oi),
                e = this.bottom.querySelector(Oi),
                i = this.items.querySelector("[data-add-action-wrapper]");
            if ((e && e.remove(), this.cartPage && t && this.bottom.insertBefore(t, this.bottom.firstChild), t && i)) {
                const t = !0;
                new bi(this.section, t);
            }
        }
        initQuantity() {
            Ti(this.container), this.initInputs(), this.initRemove();
        }
        showForm() {
            var t;
            this.bar && this.bar.classList.remove(Ri),
                this.form.classList.remove(Ri),
                this.bottom.classList.remove(Ri),
                null === (t = this.progress) || void 0 === t || t.classList.remove(Ri),
                this.loader.classList.remove(ji),
                this.emptystate.classList.add(Ri),
                this.blankState && this.blankState.classList.add(Ri);
        }
        showEmpty() {
            var t;
            this.bar && this.bar.classList.add(Ri),
                this.emptystate.classList.remove(Ri),
                this.loader.classList.remove(ji),
                this.form.classList.add(Ri),
                this.bottom.classList.add(Ri),
                null === (t = this.progress) || void 0 === t || t.classList.add(Ri),
                this.blankState && this.blankState.classList.add(Ri);
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Jt({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        constructor(t) {
            (this.section = t),
                (this.container = t.container),
                (this.bar = this.container.querySelector(zi)),
                (this.drawer = this.container.querySelector(Ai)),
                (this.form = this.container.querySelector(Ci)),
                (this.loader = this.container.querySelector(xi)),
                (this.bottom = this.container.querySelector(Ii)),
                (this.items = this.container.querySelector(_i)),
                (this.subtotal = this.container.querySelector(Di)),
                (this.errors = this.container.querySelector(Mi)),
                (this.finalPrice = this.container.querySelector(Fi)),
                (this.emptystate = this.container.querySelector(Pi)),
                (this.progress = this.container.querySelector($i)),
                (this.blankState = this.container.querySelector(Vi)),
                (this.latestClick = null),
                (this.cart = null),
                (this.stale = !0),
                (this.cartPage = document.querySelector(Ni)),
                this.listen();
        }
    };
    const Ji = {
            onLoad() {
                this.container.querySelector(Ai) && (this.cart = new Ui(this));
                this.container.querySelector(qi) && new ce(this);
            },
            onUnload: function () {
                this.cart && "function" == typeof this.cart.unload && this.cart.unload();
            },
        },
        Yi = "[data-search-popdown-wrap]",
        Ki = "data-popdown-toggle",
        Xi = "[data-close-popdown]",
        Qi = "[data-predictive-search-input]",
        Gi = "[data-search-underlay]",
        Zi = "underlay--visible",
        ts = "is-visible";
    let es = {};
    const is = {
            onLoad() {
                es[this.id] = {};
                this.container.querySelectorAll(`[${Ki}]`).forEach((t) => {
                    es[this.id] = new (class {
                        initTriggerEvents() {
                            this.trigger.setAttribute("aria-haspopup", !0),
                                this.trigger.setAttribute("aria-expanded", !1),
                                this.trigger.setAttribute("aria-controls", this.key),
                                this.trigger.addEventListener(
                                    "click",
                                    function (t) {
                                        t.preventDefault(), this.showPopdown();
                                    }.bind(this)
                                ),
                                this.trigger.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.SPACE && this.showPopdown();
                                    }.bind(this)
                                );
                        }
                        initPopdownEvents() {
                            this.popdown.addEventListener(
                                "keyup",
                                function (t) {
                                    t.which === window.theme.keyboardKeys.ESCAPE && this.hidePopdown();
                                }.bind(this)
                            ),
                                this.close.addEventListener(
                                    "click",
                                    function () {
                                        this.hidePopdown();
                                    }.bind(this)
                                ),
                                this.underlay.addEventListener(
                                    "click",
                                    function () {
                                        this.hidePopdown();
                                    }.bind(this)
                                );
                        }
                        hidePopdown() {
                            this.popdown.classList.remove(ts),
                                this.underlay.classList.remove(Zi),
                                this.trigger.focus(),
                                nt(),
                                this.input.dispatchEvent(new CustomEvent("clear", { bubbles: !1 })),
                                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }
                        showPopdown() {
                            this.popdown.classList.add(ts), this.underlay.classList.add(Zi), ot(this.popdown, { elementToFocus: this.input }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                        }
                        constructor(t) {
                            (this.trigger = t), (this.key = this.trigger.getAttribute(Ki));
                            const e = `[id='${this.key}']`;
                            (this.popdown = document.querySelector(e)),
                                (this.input = this.popdown.querySelector(Qi)),
                                (this.close = this.popdown.querySelector(Xi)),
                                (this.wrapper = this.popdown.closest(Yi)),
                                (this.underlay = this.wrapper.querySelector(Gi)),
                                this.initTriggerEvents(),
                                this.initPopdownEvents();
                        }
                    })(t);
                });
            },
        },
        ss = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : (t.style.display = i));
        },
        os = (t) => {
            t && (t.style.display = "none");
        },
        ns = 'input[type="search"]',
        rs = '[aria-selected="true"] a',
        as = 'button[type="reset"]',
        ls = "is-hidden";
    let cs = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(ls);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(ls) : 0 !== this.input.value.length || t || this.resetButton.classList.add(ls);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(rs);
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && ((this.input.value = ""), this.toggleResetButton(), t.target.querySelector(ns).focus());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(ns)),
                (this.resetButton = this.querySelector(as)),
                this.input &&
                    (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        u((t) => {
                            this.onChange(t);
                        }, 300).bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", cs);
    const hs = '[role="option"]',
        ds = '[aria-selected="true"]',
        us = "predictive-search",
        ps = "[data-predictive-search-results]",
        ms = "[data-predictive-search-status]",
        ys = "[data-predictive-search-input]",
        fs = "[data-predictive-search-live-region-count-value]",
        gs = "data-search-results-groups-wrapper",
        vs = "[data-predictive-search-search-for-text]",
        ws = "#shopify-section-predictive-search",
        bs = '[aria-selected="true"] a',
        Ss = '[aria-selected="true"] a, button[aria-selected="true"]',
        Es = "[data-loading-indicator]";
    let Ls = class extends cs {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("focusout", this.onFocusOut.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            (this.searchTerm && t.startsWith(this.searchTerm)) || null === (e = this.querySelector(gs)) || void 0 === e || e.remove();
            this.updateSearchForTerm(this.searchTerm, t), (this.searchTerm = t), this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(bs)) || t.preventDefault();
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
        }
        shouldResetForm() {
            return !document.querySelector(bs);
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
        }
        onKeyup(t) {
            switch ((this.getQuery().length || this.close(!0), t.preventDefault(), t.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        updateSearchForTerm(t, e) {
            const i = this.querySelector(vs),
                s = null == i ? void 0 : i.innerText;
            if (s) {
                var o;
                if ((null === (o = s.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                const n = s.replace(t, e);
                i.innerText = n;
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                i = this.querySelector(ds),
                s = Array.from(this.querySelectorAll(hs)).filter((t) => null !== t.offsetParent);
            let o = 0;
            if (e && !i) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= s.length; ) s[r] === i && (n = r), r++;
            if (((this.statusElement.textContent = ""), !e && i ? (o = n === s.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? s.length - 1 : n - 1), o === n)) return;
            const a = s[o];
            a.setAttribute("aria-selected", !0), i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
            const t = this.querySelector(Ss);
            t && t.click();
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(),
                this.cachedResults[e]
                    ? this.renderSearchResults(this.cachedResults[e])
                    : (ss(this.loader),
                      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, { signal: this.abortController.signal })
                          .then(this.handleErrors)
                          .then((t) => t.text())
                          .then((t) => {
                              const i = new DOMParser().parseFromString(t, "text/html").querySelector(ws).innerHTML;
                              this.allPredictiveSearchInstances.forEach((t) => {
                                  t.cachedResults[e] = i;
                              }),
                                  this.renderSearchResults(i);
                          })
                          .catch((t) => {
                              console.error(t);
                          })
                          .finally(() => {
                              os(this.loader);
                          }));
        }
        setLiveRegionLoadingState() {
            (this.statusElement = this.statusElement || this.querySelector(ms)), (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0);
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"),
                (this.statusElement.textContent = t),
                setTimeout(() => {
                    this.statusElement.setAttribute("aria-hidden", "true");
                }, 1e3);
        }
        renderSearchResults(t) {
            (this.predictiveSearchResults.innerHTML = t), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(fs).textContent);
        }
        open() {
            this.setAttribute("open", !0),
                this.input.setAttribute("aria-expanded", !0),
                (this.isOpen = !0),
                this.setViewportHeight(),
                /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                    setTimeout(() => {
                        this.setViewportHeight();
                    }, 500);
        }
        close(t = !1) {
            this.closeResults(t), (this.isOpen = !1);
        }
        closeResults(t = !1) {
            var e;
            t && ((this.input.value = ""), this.removeAttribute("results"));
            const i = this.querySelector(ds);
            i && i.setAttribute("aria-selected", !1),
                this.input.setAttribute("aria-activedescendant", ""),
                this.removeAttribute("loading"),
                this.removeAttribute("open"),
                this.input.setAttribute("aria-expanded", !1),
                null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style");
        }
        reset() {
            (this.predictiveSearchResults.innerHTML = ""), (this.input.val = ""), this.a11y.removeTrapFocus();
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new Jt({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        setViewportHeight() {
            const t = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            this.style.setProperty("--full-screen", `${t}px`);
        }
        constructor() {
            super(),
                (this.wrapper = this),
                (this.a11y = rt),
                (this.abortController = new AbortController()),
                (this.allPredictiveSearchInstances = document.querySelectorAll(us)),
                (this.cachedResults = {}),
                (this.input = this.wrapper.querySelector(ys)),
                (this.isOpen = !1),
                (this.predictiveSearchResults = this.querySelector(ps)),
                (this.searchTerm = ""),
                (this.loader = this.wrapper.querySelector(Es));
        }
    };
    function ks() {
        return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.small;
    }
    const Ts = 'input[type="search"]';
    let As = class extends cs {
        setupEventListeners() {
            let t = [];
            this.allSearchInputs.forEach((e) => t.push(e.form)),
                this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                t.length < 2 || (t.forEach((t) => t.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach((t) => t.addEventListener("input", this.onInput.bind(this))));
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input);
        }
        onInput(t) {
            const e = t.target;
            this.keepInSync(e.value, e);
        }
        onInputFocus() {
            ks() || this.scrollIntoView({ behavior: "smooth" });
        }
        keepInSync(t, e) {
            this.allSearchInputs.forEach((i) => {
                i !== e && (i.value = t);
            });
        }
        constructor() {
            super(), (this.allSearchInputs = document.querySelectorAll(Ts)), this.setupEventListeners();
        }
    };
    const qs = "[data-popout]",
        xs = "[data-popout-list]",
        Cs = "data-popout-toggle",
        Ps = "[data-popout-input]",
        $s = "[data-popout-option]",
        _s = "data-popout-prevent",
        Ds = "data-quantity-field",
        Is = "data-value",
        Ms = "aria-expanded",
        Hs = "aria-current",
        Fs = "popout-list--visible",
        Bs = "--current";
    let Ws = class extends HTMLElement {
        unload() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.removeEventListener("clickDetails", this.popupOptionsClick.bind(this)), t.removeEventListener("click", this._connectOptionsDispatch.bind(this));
                }),
                this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)),
                this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.removeEventListener("keyup", this.containerKeyup.bind(this)),
                this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)));
        }
        popupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(Ms);
            t.currentTarget.setAttribute(Ms, !e), this.popoutList.classList.toggle(Fs);
        }
        popupToggleFocusout(t) {
            this.container.contains(t.relatedTarget) || this._hideList();
        }
        popupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(Fs) && !e && this._hideList();
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest($s).attributes.href.value) {
                t.preventDefault();
                let e = "";
                if ((t.currentTarget.getAttribute(Is) && (e = t.currentTarget.getAttribute(Is)), (this.popoutInput.value = e), this.popoutPrevent)) {
                    this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(Ds) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${Bs}"]`);
                    let s = Bs;
                    if (i && i.classList.length)
                        for (const t of i.classList)
                            if (t.includes(Bs)) {
                                s = t;
                                break;
                            }
                    const o = this.popoutList.querySelector(`.${s}`);
                    o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                    const n = this.popoutList.querySelector(`[${Hs}]`);
                    n && n.hasAttribute(`${Hs}`) && (n.removeAttribute(`${Hs}`), t.currentTarget.setAttribute(`${Hs}`, "true")),
                        "" !== e && ((this.popoutToggle.textContent = e), this.outsidePopupToggle && (this.outsidePopupToggle.textContent = e)),
                        this.popupToggleFocusout(t),
                        this.popupListFocusout(t);
                } else this._submitForm(e);
            }
        }
        updatePopout(t) {
            const e = this.popoutList.querySelector(`[${Is}="${this.popoutInput.value}"]`);
            e && e.dispatchEvent(new CustomEvent("clickDetails", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !0 } }));
        }
        containerKeyup(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
        }
        bodyClick(t) {
            const e = this.container.contains(t.target),
                i = this.popoutList.classList.contains(Fs),
                s = this.outsidePopupToggle === t.target;
            !i || e || s || this._hideList();
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this));
        }
        _connectOptions() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.addEventListener("clickDetails", this.popupOptionsClick.bind(this)), t.addEventListener("click", this._connectOptionsDispatch.bind(this));
                });
        }
        _connectOptionsDispatch(t) {
            const e = new CustomEvent("clickDetails", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
            t.target.dispatchEvent(e) || t.preventDefault();
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.addEventListener("keyup", this.containerKeyup.bind(this)),
                document.body.addEventListener("click", this.bodyClick.bind(this));
        }
        _submitForm(t) {
            const e = this.container.closest("form");
            e && e.submit();
        }
        _hideList() {
            this.popoutList.classList.remove(Fs), this.popoutToggle.setAttribute(Ms, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(Ms, !1);
        }
        constructor() {
            super(),
                (this.container = this.querySelector(qs)),
                (this.popoutList = this.container.querySelector(xs)),
                (this.popoutToggle = this.container.querySelector(`[${Cs}]`)),
                (this.outsidePopupToggle = document.querySelector(`[${Cs}="${this.popoutList.id}"]`)),
                (this.popoutInput = this.container.querySelector(Ps)),
                (this.popoutOptions = this.container.querySelectorAll($s)),
                (this.popoutPrevent = "true" === this.container.getAttribute(_s)),
                this._connectOptions(),
                this._connectToggle(),
                this._onFocusOut(),
                this.popoutInput && this.popoutInput.hasAttribute(Ds) && document.addEventListener("popout:updateValue", this.updatePopout.bind(this));
        }
    };
    const Os = "[data-header-mobile] [data-ticker-frame]",
        Ns = "[data-ticker-scale]",
        zs = "[data-ticker-text]",
        Vs = "data-clone",
        Rs = "[data-header-wrapper]",
        js = "js__show__mobile",
        Us = "ticker--animated",
        Js = 1.63,
        Ys = 100,
        Ks = {};
    const Xs = {
            onLoad() {
                Ks[this.id] = [];
                this.container.querySelectorAll(Os).forEach((t) => {
                    Ks[this.id].push(
                        new (class {
                            unload() {
                                document.removeEventListener("theme:resize", this.resizeEvent);
                            }
                            listen() {
                                document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth();
                            }
                            checkWidth() {
                                const t = 2 * window.getComputedStyle(this.spaceWrapper).paddingLeft.replace("px", ""),
                                    e = this.scale.querySelector(`[${Vs}]`);
                                if ((this.header.classList.contains(js) || window.innerWidth < window.theme.sizes.small) && this.spaceWrapper.clientWidth - t < this.text.clientWidth) {
                                    if (e) return;
                                    this.scale.classList.add(Us), (this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(Vs, ""), this.scale.appendChild(this.clone);
                                    const t = (this.text.clientWidth / Ys) * Js;
                                    this.scale.style.setProperty("--animation-time", `${t}s`);
                                } else {
                                    const t = this.scale.querySelector(`[${Vs}]`);
                                    t && this.scale.removeChild(t), this.scale.classList.remove(Us);
                                }
                            }
                            constructor(t) {
                                (this.frame = t),
                                    (this.scale = this.frame.querySelector(Ns)),
                                    (this.text = this.frame.querySelector(zs)),
                                    (this.spaceWrapper = this.frame.parentNode),
                                    (this.header = document.querySelector(Rs)),
                                    (this.resizeEvent = u(() => this.checkWidth(), 100)),
                                    this.listen();
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                Ks[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Qs = {
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            dataAnimates: "data-animates",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            children:
                ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * > [data-animates],\n             :scope > * > * > * > [data-animates],\n             :scope > * > * > * > * > [data-animates],\n             :scope > * > .sliderule-grid  > *",
        },
        Gs = "is-visible",
        Zs = "is-hiding",
        to = "is-hidden";
    let eo = {};
    const io = {
            onLoad() {
                eo[this.id] = [];
                this.container.querySelectorAll(Qs.slideruleWrappper).forEach((t) => {
                    eo[this.id].push(
                        new (class {
                            clickEvents() {
                                this.trigger.addEventListener(
                                    "click",
                                    function () {
                                        this.showSliderule();
                                    }.bind(this)
                                ),
                                    this.exit.forEach((t) => {
                                        t.addEventListener(
                                            "click",
                                            function () {
                                                this.hideSliderule();
                                            }.bind(this)
                                        );
                                    });
                            }
                            keyboardEvents() {
                                this.trigger.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.SPACE && this.showSliderule();
                                    }.bind(this)
                                ),
                                    this.sliderule.addEventListener(
                                        "keyup",
                                        function (t) {
                                            t.which === window.theme.keyboardKeys.ESCAPE && (this.hideSliderule(), this.buttons[0].focus());
                                        }.bind(this)
                                    );
                            }
                            staggerChildAnimations(t = !1) {
                                (t ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach((t, e) => {
                                    t.style.transitionDelay = 50 * e + 10 + "ms";
                                });
                            }
                            scrollSliderule() {
                                const t = document.querySelectorAll(`[${Qs.sliderulePane}], ${Qs.slideruleWrappper}.is-visible`);
                                t.length &&
                                    t.forEach((t) => {
                                        t.scrollTop > 0 && (t.scrollTop = 0);
                                    });
                            }
                            hideSliderule(t = !1) {
                                this.scrollSliderule();
                                const e = window.getComputedStyle(this.pane),
                                    i = 1e3 * parseFloat(e.getPropertyValue("transition-duration")),
                                    s = t ? this.pane.querySelectorAll(`.${Gs}`) : this.children;
                                this.pane.style.setProperty("--sliderule-height", "auto"),
                                    this.staggerChildAnimations(!0),
                                    this.pane.classList.add(Zs),
                                    this.sliderule.classList.add(Zs),
                                    this.sliderule.classList.remove(Gs),
                                    s.forEach((t) => {
                                        t.classList.remove(Gs);
                                    });
                                const o = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                                this.pane.setAttribute(Qs.sliderulePane, o);
                                const n = t ? `[${Qs.dataAnimates}].${to}` : `[${Qs.dataAnimates}="${o}"].${to}`,
                                    r = this.pane.querySelectorAll(n);
                                r.length &&
                                    r.forEach((t) => {
                                        t.classList.remove(to);
                                    }),
                                    setTimeout(() => {
                                        this.pane.classList.remove(Zs), this.sliderule.classList.remove(Zs), this.staggerChildAnimations();
                                    }, i);
                                const a = parseInt(this.trigger.parentElement.parentElement.offsetHeight);
                                this.pane.style.setProperty("--sliderule-height", `${a}px`);
                            }
                            showSliderule() {
                                this.scrollSliderule(),
                                    this.pane.style.setProperty("--sliderule-height", "auto"),
                                    this.sliderule.classList.add(Gs),
                                    this.children.forEach((t) => {
                                        t.classList.add(Gs);
                                    });
                                const t = parseInt(this.pane.dataset.sliderulePane, 10),
                                    e = t + 1;
                                this.pane.setAttribute(Qs.sliderulePane, e);
                                const i = this.pane.querySelectorAll(`[${Qs.dataAnimates}="${t}"]`);
                                if (i.length) {
                                    const t = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                                    setTimeout(() => {
                                        i.forEach((t) => {
                                            t.classList.add(to);
                                        });
                                    }, t);
                                }
                                const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                                this.pane.style.setProperty("--sliderule-height", `${s}px`);
                            }
                            closeSliderule() {
                                this.pane &&
                                    this.pane.hasAttribute(Qs.sliderulePane) &&
                                    parseInt(this.pane.getAttribute(Qs.sliderulePane)) > 0 &&
                                    (this.hideSliderule(!0), parseInt(this.pane.getAttribute(Qs.sliderulePane)) > 0 && this.pane.setAttribute(Qs.sliderulePane, 0));
                            }
                            constructor(t) {
                                (this.sliderule = t), (this.wrapper = t.closest(Qs.wrapper)), (this.key = this.sliderule.id);
                                const e = `[${Qs.slideruleOpen}='${this.key}']`,
                                    i = `[${Qs.slideruleClose}='${this.key}']`;
                                (this.trigger = document.querySelector(e)),
                                    (this.exit = document.querySelectorAll(i)),
                                    (this.pane = document.querySelector(`[${Qs.sliderulePane}]`)),
                                    (this.children = this.sliderule.querySelectorAll(Qs.children)),
                                    this.trigger.setAttribute("aria-haspopup", !0),
                                    this.trigger.setAttribute("aria-expanded", !1),
                                    this.trigger.setAttribute("aria-controls", this.key),
                                    this.clickEvents(),
                                    this.staggerChildAnimations(),
                                    document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this));
                            }
                        })(t)
                    );
                });
            },
        },
        so = "[data-accordion-group]",
        oo = "data-accordion-trigger",
        no = "[data-accordion-body]",
        ro = "data-accordion-body-mobile",
        ao = "data-accordion-image",
        lo = "data-range-holder",
        co = "[data-section-id]",
        ho = "accordion-is-open",
        uo = "is-expanded",
        po = "is-transitioning";
    let mo = {};
    const yo = {
            onLoad() {
                mo[this.id] = [];
                this.container.querySelectorAll(no).forEach((t) => {
                    mo[this.id].push(
                        new (class {
                            mobileAccordions() {
                                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
                                    document.addEventListener("theme:resize", () => {
                                        window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"));
                                    });
                            }
                            init() {
                                this.trigger.setAttribute("aria-haspopup", !0),
                                    this.trigger.setAttribute("aria-expanded", !1),
                                    this.trigger.setAttribute("aria-controls", this.key),
                                    this.setDefaultState(),
                                    this.trigger.addEventListener("click", this.toggleEvent),
                                    this.body.addEventListener("keyup", this.keyboardEvent),
                                    this.body.addEventListener("theme:accordion:close", this.hideEvent);
                            }
                            hideEvents() {
                                this.hideAccordion();
                            }
                            clickEvents(t) {
                                t.preventDefault(), this.toggleState();
                            }
                            keyboardEvents(t) {
                                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideAccordion(), this.trigger.focus());
                            }
                            resetMobileAccordions() {
                                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent);
                            }
                            setDefaultState() {
                                this.trigger.classList.contains(ho) ? ss(this.body) : this.hideAccordion();
                            }
                            getSiblings() {
                                const t = [...this.section.querySelectorAll(so)].filter((t) => t.contains(this.body)).shift();
                                return t ? [...t.querySelectorAll(no)].filter((t) => !t.contains(this.body)) : [];
                            }
                            closeSiblings() {
                                this.syncBodies.forEach((t) => {
                                    t.dispatchEvent(new CustomEvent("theme:accordion:close", { bubbles: !1 }));
                                });
                            }
                            toggleState() {
                                this.trigger.parentElement.querySelector(no).classList.contains(po) ||
                                    (this.trigger.classList.contains(ho)
                                        ? this.hideAccordion()
                                        : (this.showAccordion(),
                                          this.closeSiblings(),
                                          this.body.hasAttribute(lo) &&
                                              setTimeout(() => {
                                                  document.dispatchEvent(new CustomEvent("theme:reset-price-range", { bubbles: !1 }));
                                              }, 400)),
                                    this.body.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } })));
                            }
                            hideAccordion() {
                                this.trigger.classList.remove(ho), Kt(this.body);
                            }
                            showAccordion() {
                                this.trigger.classList.add(ho), Yt(this.body), this.showAccordionImage();
                            }
                            showAccordionImage() {
                                const t = this.section.querySelector(`[${ao}="${this.key}"]`) || this.section.querySelector(`[${ao}=""]`);
                                var e;
                                t && this.section && (null === (e = this.section.querySelector(`[${ao}].${uo}`)) || void 0 === e || e.classList.remove(uo), t.classList.add(uo));
                            }
                            onBlockSelect(t) {
                                this.body.contains(t.target) && this.showAccordion();
                            }
                            onBlockDeselect(t) {
                                this.body.contains(t.target) && this.hideAccordion();
                            }
                            constructor(t) {
                                (this.body = t), (this.key = this.body.id);
                                const e = `[${oo}='${this.key}']`;
                                (this.trigger = document.querySelector(e)),
                                    (this.section = this.body.closest(co)),
                                    (this.toggleEvent = (t) => this.clickEvents(t)),
                                    (this.keyboardEvent = (t) => this.keyboardEvents(t)),
                                    (this.hideEvent = () => this.hideEvents()),
                                    (this.syncBodies = this.getSiblings()),
                                    this.body.hasAttribute(ro) ? this.mobileAccordions() : this.init();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                mo[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
            onSelect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${oo}]`).click();
            },
            onDeselect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${oo}]`).click();
            },
            onBlockSelect(t) {
                mo[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                mo[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
            },
        },
        fo = "html",
        go = "[data-takes-space-wrapper]",
        vo = "[data-child-takes-space]",
        wo = "[data-header-desktop]",
        bo = "js__header__clone",
        So = "js__show__mobile",
        Eo = "[data-header-backfill]",
        Lo = "data-header-transparent",
        ko = "header-override-border",
        To = ".main-content > .shopify-section:first-child [data-overlay-header]",
        Ao = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        qo = '.navlink[href="#"]';
    let xo = {};
    J("header", [
        {
            onLoad() {
                (xo = new (class {
                    unload() {
                        document.removeEventListener("theme:resize:width", this.resizeEventWidth), document.removeEventListener("theme:resize:width", this.resizeEventOverlay);
                    }
                    checkForImage() {
                        this.overlayedImages = document.querySelectorAll(To);
                        let t = document.querySelectorAll(Ao).length;
                        this.overlayedImages.length && !t && this.isTransparentHeader
                            ? (this.listenOverlay(), this.wrapper.setAttribute(Lo, !0), (document.querySelector(Eo).style.display = "none"), (theme.transparentHeader = !0))
                            : (this.wrapper.setAttribute(Lo, !1), (document.querySelector(Eo).style.display = "block"), (theme.transparentHeader = !1)),
                            !this.overlayedImages.length || t || this.isTransparentHeader || (this.wrapper.classList.add(ko), this.subtractHeaderHeight());
                    }
                    listenOverlay() {
                        document.addEventListener("theme:resize:width", this.resizeEventOverlay), this.subtractAnnouncementHeight();
                    }
                    listenWidth() {
                        document.addEventListener("theme:resize:width", this.resizeEventWidth), this.checkWidth();
                    }
                    killDeadLinks() {
                        this.deadLinks.forEach((t) => {
                            t.onclick = (t) => {
                                t.preventDefault();
                            };
                        });
                    }
                    subtractAnnouncementHeight() {
                        const { windowHeight: t, announcementHeight: e, headerHeight: i } = A();
                        this.overlayedImages.forEach((s) => {
                            s.style.setProperty("--full-screen", t - e + "px"), s.style.setProperty("--header-padding", `${i}px`), s.classList.add("has-overlay");
                        });
                    }
                    subtractHeaderHeight() {
                        const { windowHeight: t, headerHeight: e } = A();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", t - e + "px");
                        });
                    }
                    checkWidth() {
                        document.body.clientWidth < this.minWidth || document.body.clientWidth < window.theme.sizes.medium ? this.wrapper.classList.add(So) : this.wrapper.classList.remove(So);
                    }
                    getMinWidth() {
                        const t = this.wrapper.cloneNode(!0);
                        t.classList.add(bo), document.body.appendChild(t);
                        const e = t.querySelectorAll(go);
                        let i = 0,
                            s = 0;
                        return (
                            e.forEach((t) => {
                                const e = t.querySelectorAll(vo);
                                let o = 0;
                                (o =
                                    3 === e.length
                                        ? (function (t) {
                                              let e = [];
                                              return (
                                                  t.forEach((t) => {
                                                      t.firstElementChild && e.push(t.firstElementChild.clientWidth);
                                                  }),
                                                  e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                                                  e.reduce((t, e) => t + e)
                                              );
                                          })(e)
                                        : (function (t) {
                                              let e = 0;
                                              return (
                                                  t.forEach((t) => {
                                                      e += t.clientWidth;
                                                  }),
                                                  e
                                              );
                                          })(e)),
                                    o > i && ((i = o), (s = 20 * e.length));
                            }),
                            document.body.removeChild(t),
                            i + s
                        );
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.html = document.querySelector(fo)),
                            (this.style = this.wrapper.dataset.style),
                            (this.desktop = this.wrapper.querySelector(wo)),
                            (this.isTransparentHeader = "false" !== this.wrapper.getAttribute(Lo)),
                            (this.overlayedImages = document.querySelectorAll(To)),
                            (this.deadLinks = document.querySelectorAll(qo)),
                            (this.resizeEventWidth = () => this.checkWidth()),
                            (this.resizeEventOverlay = () => this.subtractAnnouncementHeight()),
                            this.killDeadLinks(),
                            "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                            this.checkForImage(),
                            document.addEventListener("theme:header:check", this.checkForImage.bind(this)),
                            this.html.style.setProperty("--scrollbar-width", window.innerWidth - this.html.clientWidth + "px");
                    }
                })(this.container)),
                    q();
            },
            onUnload() {
                "function" == typeof xo.unload && xo.unload();
            },
        },
        wt,
        io,
        Ji,
        $t,
        Rt,
        Ut,
        is,
        yo,
        Xs,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", Ws),
        customElements.get("predictive-search") || customElements.define("predictive-search", Ls),
        customElements.get("main-search") || customElements.define("main-search", As),
        J("accordion", yo);
    const Co = "[data-sort-enabled]",
        Po = "[data-sort-link]",
        $o = "data-value";
    let _o = {};
    const Do = {
            onLoad() {
                _o[this.id] = new (class {
                    init() {
                        this.sort && this.initClick();
                    }
                    onClick(t) {
                        t.preventDefault();
                        const e = t.currentTarget.getAttribute($o),
                            i = new window.URL(window.location.href),
                            s = i.searchParams;
                        s.set("sort_by", e), (i.search = s.toString()), window.location.replace(i.toString());
                    }
                    initClick() {
                        this.sortLinks.length &&
                            this.sortLinks.forEach((t) => {
                                t.addEventListener("click", (t) => this.onClick(t));
                            });
                    }
                    constructor(t) {
                        (this.container = t.container), (this.sort = this.container.querySelector(Co)), (this.sortLinks = this.container.querySelectorAll(Po)), this.init();
                    }
                })(this);
            },
        },
        Io = "data-filters",
        Mo = "data-sidebar-filter-form",
        Ho = "data-filters-toggle",
        Fo = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        Bo = "data-group-heading",
        Wo = "data-show-more",
        Oo = "drawer--visible",
        No = "filters--default-visible",
        zo = "is-hidden",
        Vo = {};
    const Ro = {
            onLoad() {
                Vo[this.id] = [];
                this.container.querySelectorAll(`[${Io}]`).forEach((t) => {
                    Vo[this.id].push(
                        new (class {
                            unload() {
                                this.filtersToggleButtons.length &&
                                    this.filtersToggleButtons.forEach((t) => {
                                        t.removeEventListener("click", this.connectToggleMemory);
                                    }),
                                    this.showMoreButtons.length &&
                                        this.showMoreButtons.forEach((t) => {
                                            t.addEventListener("click", this.connectShowHiddenOptions);
                                        });
                            }
                            expandingEvents() {
                                this.showMoreButtons.length &&
                                    this.showMoreButtons.forEach((t) => {
                                        t.addEventListener(
                                            "click",
                                            ((t, e) => {
                                                let i, s;
                                                return function o(...n) {
                                                    const r = Date.now();
                                                    (s = clearTimeout(s)), !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
                                                };
                                            })(this.connectShowHiddenOptions, 500)
                                        );
                                    });
                            }
                            showHiddenOptions(t) {
                                const e = t.target.hasAttribute(Wo) ? t.target : t.target.closest(`[${Wo}]`);
                                e.classList.add(zo),
                                    e.previousElementSibling.querySelectorAll(`.${zo}`).forEach((t) => {
                                        t.classList.remove(zo);
                                    });
                            }
                            connectToggle() {
                                this.filtersToggleButtons.forEach((t) => {
                                    t.addEventListener("click", this.connectToggleMemory.bind(this));
                                });
                            }
                            connectToggleFunction(t) {
                                window.innerWidth < window.theme.sizes.medium && ("true" === t.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters());
                            }
                            showFilters() {
                                setTimeout(() => {
                                    this.filtersToggleButtons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                        this.filtersToggleButtons.forEach((t) => t.classList.add(Oo)),
                                        this.form.classList.add(Oo),
                                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                                        this.form.querySelector(Fo).focus();
                                }, 10);
                            }
                            hideFilters() {
                                this.filtersToggleButtons.forEach((t) => t.setAttribute("aria-expanded", !1)),
                                    this.filtersToggleButtons.forEach((t) => t.classList.remove(Oo)),
                                    this.filtersToggleButtons.forEach((t) => t.classList.remove(No)),
                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                    this.form.classList.remove(Oo);
                            }
                            constructor(t) {
                                (this.container = t),
                                    (this.groupHeadings = this.container.querySelectorAll(`[${Bo}]`)),
                                    (this.showMoreButtons = this.container.querySelectorAll(`[${Wo}]`)),
                                    (this.form = this.container.querySelector(`[${Mo}]`));
                                const e = this.form.getAttribute(Mo),
                                    i = `[${Ho}='${e}']`;
                                (this.filtersToggleButtons = document.querySelectorAll(i)),
                                    (this.connectToggleMemory = (t) => this.connectToggleFunction(t)),
                                    (this.connectShowHiddenOptions = (t) => this.showHiddenOptions(t)),
                                    this.connectToggle(),
                                    this.expandingEvents();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                Vo[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        jo = "[data-range-slider]",
        Uo = "[data-range-left]",
        Jo = "[data-range-right]",
        Yo = "[data-range-line]",
        Ko = "[data-range-holder]",
        Xo = "data-se-min",
        Qo = "data-se-max",
        Go = "data-se-min-value",
        Zo = "data-se-max-value",
        tn = "data-se-step",
        en = "data-range-filter-update",
        sn = "[data-field-price-min]",
        on = "[data-field-price-max]",
        nn = "is-initialized";
    const rn = "[data-swapper-wrapper]",
        an = "[data-swapper-target]",
        ln = "[data-swapper-input]",
        cn = "data-swapper-hover";
    let hn = {},
        dn = class {
            init() {
                this.inputs.forEach((t) => {
                    t.addEventListener(
                        "change",
                        function () {
                            this.deafaultContent = t.getAttribute("value");
                        }.bind(this)
                    );
                }),
                    this.hovers.forEach((t) => {
                        t.addEventListener(
                            "mouseenter",
                            function () {
                                const e = t.getAttribute(cn);
                                this.target.innerHTML = `${e}`;
                            }.bind(this)
                        ),
                            t.addEventListener(
                                "mouseleave",
                                function () {
                                    this.target.innerHTML = this.deafaultContent;
                                }.bind(this)
                            );
                    });
            }
            constructor(t) {
                (this.container = t),
                    (this.target = this.container.querySelector(an)),
                    (this.inputs = this.container.querySelectorAll(ln)),
                    (this.hovers = this.container.querySelectorAll(`[${cn}]`)),
                    this.target && this.hovers.length && ((this.deafaultContent = this.target.innerHTML), this.init());
            }
        };
    const un = {
            onLoad() {
                var t;
                (hn[(t = this).id] = []),
                    t.container.querySelectorAll(rn).forEach((e) => {
                        hn[t.id].push(new dn(e));
                    });
            },
        },
        pn = "[data-sidebar-filter-form]",
        mn = "input, select, label, textarea",
        yn = "[data-field-price-min]",
        fn = "[data-field-price-max]",
        gn = "data-field-price-min",
        vn = "data-field-price-max",
        wn = "[data-se-min-value]",
        bn = "[data-se-max-value]",
        Sn = "data-se-min-value",
        En = "data-se-max-value",
        Ln = "data-se-min",
        kn = "data-se-max",
        Tn = "[data-color-filter]";
    const An = {
        onLoad() {
            this.filterForm = new (class {
                init() {
                    this.form.querySelectorAll(Tn).forEach((t) => {
                        new dn(t);
                    }),
                        this.filtersInputs.length &&
                            this.filtersInputs.forEach((t) => {
                                t.addEventListener(
                                    "input",
                                    u(() => {
                                        if (this.form && "function" == typeof this.form.submit) {
                                            if (t.hasAttribute(gn) || t.hasAttribute(vn)) {
                                                const t = parseInt(this.rangeMin.getAttribute(Ln)),
                                                    e = parseInt(this.rangeMax.getAttribute(kn));
                                                this.priceMin.value && !this.priceMax.value && (this.priceMax.value = e),
                                                    this.priceMax.value && !this.priceMin.value && (this.priceMin.value = t),
                                                    this.priceMin.value <= t && this.priceMax.value >= e && ((this.priceMin.placeholder = t), (this.priceMax.placeholder = e), (this.priceMin.value = ""), (this.priceMax.value = ""));
                                            }
                                            this.form.submit();
                                        }
                                    }, 500)
                                );
                            }),
                        this.form.addEventListener("range:filter:update", () => this.updateRange());
                }
                updateRange() {
                    if (this.form && "function" == typeof this.form.submit && this.rangeMin && this.rangeMax && this.priceMin && this.priceMax && this.rangeMin.hasAttribute(Sn) && this.rangeMax.hasAttribute(En)) {
                        const t = parseInt(this.priceMin.placeholder),
                            e = parseInt(this.priceMax.placeholder),
                            i = parseInt(this.rangeMin.getAttribute(Sn)),
                            s = parseInt(this.rangeMax.getAttribute(En));
                        (t === i && e === s) ||
                            ((this.priceMin.value = i), (this.priceMax.value = s), this.priceMin.dispatchEvent(new CustomEvent("input", { bubbles: !0 })), this.priceMax.dispatchEvent(new CustomEvent("input", { bubbles: !0 })));
                    }
                }
                constructor(t) {
                    (this.form = t.container.querySelector(pn)),
                        (this.filtersInputs = []),
                        this.form &&
                            (new (class {
                                init() {
                                    this.setDefaultValues(),
                                        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                                        this.touchRight.addEventListener("mousedown", this.onStartEvent),
                                        this.touchLeft.addEventListener("touchstart", this.onStartEvent),
                                        this.touchRight.addEventListener("touchstart", this.onStartEvent),
                                        this.slider.classList.add(nn);
                                }
                                setDefaultValues() {
                                    let t = this.min;
                                    this.slider.hasAttribute(Go) && (t = parseFloat(this.slider.getAttribute(Go)));
                                    let e = this.max;
                                    this.slider.hasAttribute(Zo) && (e = parseFloat(this.slider.getAttribute(Zo))),
                                        t < this.min && (t = this.min),
                                        e > this.max && (e = this.max),
                                        t > e && (t = e),
                                        this.slider.getAttribute(tn) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(tn)))),
                                        this.reset(),
                                        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                                        (this.selectedTouch = null),
                                        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                                        this.setMinValue(t),
                                        this.setMaxValue(e);
                                }
                                reset() {
                                    (this.touchLeft.style.left = "0px"),
                                        (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                                        (this.lineSpan.style.marginLeft = "0px"),
                                        (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                                        (this.startX = 0),
                                        (this.x = 0);
                                }
                                setMinValue(t) {
                                    const e = (t - this.min) / (this.max - this.min);
                                    (this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                                        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                                        (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                                        this.slider.setAttribute(Go, t);
                                }
                                setMaxValue(t) {
                                    const e = (t - this.min) / (this.max - this.min);
                                    (this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                                        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                                        (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                                        this.slider.setAttribute(Zo, t);
                                }
                                onStart(t) {
                                    t.preventDefault();
                                    let e = t;
                                    t.touches && (e = t.touches[0]),
                                        t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                                        (this.startX = e.pageX - this.x),
                                        (this.selectedTouch = t.currentTarget),
                                        document.addEventListener("mousemove", this.onMoveEvent),
                                        document.addEventListener("mouseup", this.onStopEvent),
                                        document.addEventListener("touchmove", this.onMoveEvent),
                                        document.addEventListener("touchend", this.onStopEvent);
                                }
                                onMove(t) {
                                    let e = t;
                                    t.touches && (e = t.touches[0]),
                                        (this.x = e.pageX - this.startX),
                                        this.selectedTouch === this.touchLeft
                                            ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                                              (this.selectedTouch.style.left = this.x + "px"))
                                            : this.selectedTouch === this.touchRight &&
                                              (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                                              (this.selectedTouch.style.left = this.x + "px")),
                                        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                                        (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                                        this.calculateValue(),
                                        this.slider.getAttribute("on-change") && new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(Go), this.slider.getAttribute(Zo)),
                                        this.onChange(this.slider.getAttribute(Go), this.slider.getAttribute(Zo));
                                }
                                onStop(t) {
                                    document.removeEventListener("mousemove", this.onMoveEvent),
                                        document.removeEventListener("mouseup", this.onStopEvent),
                                        document.removeEventListener("touchmove", this.onMoveEvent),
                                        document.removeEventListener("touchend", this.onStopEvent),
                                        (this.selectedTouch = null),
                                        this.calculateValue(),
                                        this.onChanged(this.slider.getAttribute(Go), this.slider.getAttribute(Zo));
                                }
                                onChange(t, e) {
                                    const i = this.slider.closest(Ko);
                                    if (i) {
                                        const s = i.querySelector(sn),
                                            o = i.querySelector(on);
                                        s && o && ((s.value = t), (o.value = e));
                                    }
                                }
                                onChanged(t, e) {
                                    this.slider.hasAttribute(en) && this.slider.dispatchEvent(new CustomEvent("range:filter:update", { bubbles: !0 }));
                                }
                                calculateValue() {
                                    const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
                                    let e = this.lineSpan.offsetLeft / this.initialValue,
                                        i = e + t;
                                    if (((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                                        let t = Math.floor(e / this.step);
                                        (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
                                    }
                                    this.selectedTouch === this.touchLeft && this.slider.setAttribute(Go, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(Zo, i);
                                }
                                unload() {
                                    window.removeEventListener("resize", this.onResize),
                                        this.touchLeft.removeEventListener("mousedown", this.onStartEvent),
                                        this.touchRight.removeEventListener("mousedown", this.onStartEvent),
                                        this.touchLeft.removeEventListener("touchstart", this.onStartEvent),
                                        this.touchRight.removeEventListener("touchstart", this.onStartEvent);
                                }
                                constructor(t) {
                                    (this.container = t.container),
                                        (this.slider = t.querySelector(jo)),
                                        this.slider &&
                                            ((this.onMoveEvent = (t) => this.onMove(t)),
                                            (this.onStopEvent = (t) => this.onStop(t)),
                                            (this.onStartEvent = (t) => this.onStart(t)),
                                            (this.onResize = () => this.setDefaultValues()),
                                            (this.startX = 0),
                                            (this.x = 0),
                                            (this.touchLeft = this.slider.querySelector(Uo)),
                                            (this.touchRight = this.slider.querySelector(Jo)),
                                            (this.lineSpan = this.slider.querySelector(Yo)),
                                            (this.min = parseFloat(this.slider.getAttribute(Xo))),
                                            (this.max = parseFloat(this.slider.getAttribute(Qo))),
                                            (this.step = 0),
                                            (this.normalizeFact = 26),
                                            this.init(),
                                            document.addEventListener("theme:reset-price-range", () => {
                                                this.setDefaultValues();
                                            }),
                                            window.addEventListener("resize", this.onResize));
                                }
                            })(this.form),
                            (this.filtersInputs = this.form.querySelectorAll(mn)),
                            (this.priceMin = this.form.querySelector(yn)),
                            (this.priceMax = this.form.querySelector(fn)),
                            (this.rangeMin = this.form.querySelector(wn)),
                            (this.rangeMax = this.form.querySelector(bn)),
                            this.init());
                }
            })(this);
        },
        onUnload: function () {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload();
        },
    };
    var qn = "[data-collection-sidebar]",
        xn = ".collection-nav--grouped",
        Cn = ".collection__sidebar__heading",
        Pn = ".link--add",
        $n = ".link--remove";
    J("collection", [
        {
            onLoad() {
                this.collection = new (class {
                    init() {
                        this.removeUnusableFilters();
                    }
                    removeUnusableFilters() {
                        const t = this.container.querySelectorAll(xn);
                        t.length > 0 &&
                            t.forEach((t) => {
                                const e = t.querySelector(Pn),
                                    i = t.querySelector($n);
                                e || i || (os(t), os(t.parentElement.querySelector(Cn)));
                            });
                    }
                    constructor(t) {
                        (this.container = t.container), (this.sidebar = this.container.querySelector(qn)), this.init();
                    }
                })(this);
            },
        },
        Do,
        Ro,
        An,
        yo,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", Ws);
    const _n = "data-slideshow",
        Dn = "data-slide",
        In = "data-slide-index",
        Mn = "[data-prev-arrow]",
        Hn = "[data-next-arrow]",
        Fn = "[data-slider-actions]",
        Bn = "flickity-disabled-mobile",
        Wn = "flickity-enabled",
        On = "data-minimum",
        Nn = { minimumVisibleSlidesDesktop: 4, minimumVisibleSlidesTablet: 2, minimumVisibleSlidesSmallMobile: 1 },
        zn = "hide",
        Vn = {};
    let Rn = class {
        init() {
            (this.flkty = new l(this.slideshow, { cellAlign: "left", groupCells: !0, pageDots: !1, contain: !0, prevNextButtons: !1, watchCSS: !0 })),
                this.prevArrow &&
                    this.prevArrow.addEventListener("click", (t) => {
                        t.preventDefault(), this.flkty.previous();
                    }),
                this.nextArrow &&
                    this.nextArrow.addEventListener("click", (t) => {
                        t.preventDefault(), this.flkty.next();
                    }),
                this.flkty.on("change", () => this.setButtonStatus()),
                this.flkty.on("select", () => {
                    (this.flkty.options.draggable = !0), this.flkty.updateDraggable();
                }),
                this.showSliderActions(),
                this.stopSlider(),
                document.addEventListener("theme:resize", this.resizeEvent);
        }
        setButtonStatus(t = !1) {
            if (this.flkty && this.flkty.slides && this.nextArrow && this.prevArrow) {
                t && this.flkty.reposition();
                const e = this.flkty.selectedIndex;
                e == this.flkty.slides.length - 1 ? this.nextArrow.setAttribute("disabled", "") : this.nextArrow.removeAttribute("disabled"),
                    0 === e ? this.prevArrow.setAttribute("disabled", "") : this.prevArrow.removeAttribute("disabled");
            }
        }
        showSliderActions() {
            let t = !0;
            if (this.flkty && this.flkty.cells && this.flkty.cells.length) {
                const e = this.flkty.cells.length > this.config.minimumVisibleSlidesDesktop && window.innerWidth >= window.theme.sizes.large,
                    i = this.flkty.cells.length > this.config.minimumVisibleSlidesTablet && window.innerWidth < window.theme.sizes.large,
                    s = this.flkty.cells.length > this.config.minimumVisibleSlidesSmallMobile && window.innerWidth < window.theme.sizes.small;
                (e || i || s) && (t = !1);
            }
            this.sliderActions && this.sliderActions.classList.toggle(zn, t);
        }
        stopSlider() {
            var t;
            window.innerWidth < window.theme.sizes.medium && (null === (t = this.slideshow) || void 0 === t ? void 0 : t.classList.contains(Bn)) && new Se(this.container);
        }
        resizeEvents() {
            this.setButtonStatus(!0), this.showSliderActions(), this.stopSlider();
        }
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent), this.flkty && this.flkty.destroy();
        }
        onBlockSelect(t) {
            if (this.slideshow) {
                const e = this.slideshow.querySelector(`[${Dn}="${t.detail.blockId}"]`);
                if (e) {
                    const t = parseInt(e.getAttribute(In));
                    this.flkty && this.flkty.element && this.flkty.element.classList.contains(Wn) && this.flkty.selectCell(t);
                }
            }
        }
        constructor(t) {
            (this.container = t),
                (this.slideshow = this.container.querySelector(`[${_n}]`)),
                (this.sliderActions = this.container.querySelector(Fn)),
                (this.prevArrow = this.container.querySelector(Mn)),
                (this.nextArrow = this.container.querySelector(Hn)),
                (this.flkty = null),
                (this.resizeEvent = () => this.resizeEvents()),
                this.slideshow
                    ? ((Nn.minimumVisibleSlidesDesktop = Number(this.slideshow.getAttribute(_n)) ? Number(this.slideshow.getAttribute(_n)) : Nn.minimumVisibleSlidesDesktop),
                      (Nn.minimumVisibleSlidesDesktop = Number(this.container.getAttribute(On)) ? Number(this.container.getAttribute(On)) : Nn.minimumVisibleSlidesDesktop),
                      (this.config = { ...Nn }),
                      this.init())
                    : this.stopSlider(!0);
        }
    };
    const jn = {
        onLoad() {
            Vn[this.id] = new Rn(this.container);
        },
        onBlockSelect(t) {
            "function" == typeof Vn[this.id].onBlockSelect && Vn[this.id].onBlockSelect(t);
        },
        onUnload() {
            "function" == typeof Vn[this.id].unload && Vn[this.id].unload();
        },
    };
    J("section-collection", jn);
    const Un = { cc_load_policy: 1, iv_load_policy: 3, modestbranding: 1, playsinline: 1, controls: 1, showinfo: 0, ecver: 2, fs: 1, rel: 0 };
    function Jn(t, e) {
        const i = { ...Un, ...e },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector("iframe, [data-replace]"),
            n = s.querySelector("[data-video-id]").getAttribute("data-video-id");
        window.isYoutubeAPILoaded || (Oe({ url: "https://www.youtube.com/iframe_api" }), (window.isYoutubeAPILoaded = !0));
        return window.youtubeLoaderPromise
            .then(function () {
                let t = new window.YT.Player(o, { videoId: n, playerVars: { ...i } });
                return (
                    s.addEventListener("pause", function () {
                        try {
                            t.pauseVideo && t.pauseVideo();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("play-desktop", function () {
                        ke() || s.dispatchEvent(new Event("play"));
                    }),
                    s.addEventListener("play", function () {
                        try {
                            t.playVideo
                                ? t.playVideo()
                                : t.addEventListener("onReady", function (t) {
                                      t.target.playVideo();
                                  });
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("destroy", function () {
                        try {
                            t.destroy && t.destroy();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    t
                );
            })
            .catch(function (t) {
                console.error(t);
            });
    }
    window.youtubeLoaderPromise = new Promise((t) => {
        window.onYouTubeIframeAPIReady = function () {
            t();
        };
    });
    const Yn = "[data-video-button]",
        Kn = "[data-background-video]",
        Xn = "data-unique",
        Qn = "data-video-id",
        Gn = "data-video-type",
        Zn = "data-player";
    const tr = {
        onLoad() {
            new (class {
                init() {
                    this.triggers.forEach((t) => {
                        const e = t.getAttribute(Xn),
                            i = t.getAttribute(Qn),
                            s = t.getAttribute(Gn),
                            o = `${i}-${e}`,
                            n = document.querySelector(`[${Zn}="${o}"]`);
                        r.init({
                            onShow: () => {
                                this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                let t = {};
                                "youtube" === s ? (t = Jn(o)) : "vimeo" === s && (t = Ve(o)),
                                    t.then(() => {
                                        n.dispatchEvent(new CustomEvent("play"));
                                    });
                            },
                            onClose: (t, e, i) => {
                                i.preventDefault(), n.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play();
                            },
                            openTrigger: `data-trigger-${i}-${e}`,
                        });
                    });
                }
                constructor(t) {
                    (this.container = t.container), (this.triggers = this.container.querySelectorAll(Yn)), (this.backgroundVideo = this.container.querySelector(Kn)), this.init();
                }
            })(this);
        },
    };
    J("section-custom-content", [jn, tr]);
    var er = {};
    const ir = {
            onLoad() {
                er[this.id] = [];
                this.container.querySelectorAll("[data-parallax-wrapper]").forEach((t) => {
                    const e = t.querySelector("[data-parallax-img]");
                    er[this.id].push(new c(e, { center: !0, round: !0, frame: t }));
                });
            },
            onUnload: function () {
                er[this.id].forEach((t) => {
                    "function" == typeof t.destroy && t.destroy();
                });
            },
        },
        sr = "[data-block-scroll]",
        or = "flickity-enabled",
        nr = {};
    const rr = {
            onLoad() {
                nr[this.id] = new (class {
                    onBlockSelect(t) {
                        const e = this.container.querySelector(sr);
                        if (e && !e.classList.contains(or)) {
                            const i = t.srcElement;
                            i && e.scrollTo({ top: 0, left: i.offsetLeft, behavior: "smooth" });
                        }
                    }
                    constructor(t) {
                        this.container = t.container;
                    }
                })(this);
            },
            onBlockSelect(t) {
                nr[this.id].onBlockSelect(t);
            },
        },
        ar = {},
        lr = "[data-section-timeline-slideshow]",
        cr = "[data-timeline-text-height]",
        hr = "[data-has-image]",
        dr = "flickity-disabled-mobile",
        ur = "flickity-enabled";
    J("section-timeline", [
        {
            onLoad() {
                ar[this.id] = new (class {
                    init() {
                        (this.flkty = new l(this.slides, { cellAlign: "left", adaptiveHeight: !1, groupCells: !0, pageDots: !1, contain: !0, watchCSS: !0 })),
                            this.flkty.on("select", () => {
                                (this.flkty.options.draggable = !0), this.flkty.updateDraggable();
                            }),
                            this.stopSlider(),
                            document.addEventListener("theme:resize", () => {
                                this.stopSlider();
                            });
                    }
                    stopSlider() {
                        var t;
                        window.innerWidth < window.theme.sizes.medium && (null === (t = this.slides) || void 0 === t ? void 0 : t.classList.contains(dr)) && new Se(this.container);
                    }
                    onBlockSelect(t) {
                        const e = t.target.closest("[data-slideshow-index]").getAttribute("data-slideshow-index"),
                            i = parseInt(e, 10);
                        this.flkty && this.flkty.element && this.flkty.element.classList.contains(ur) && (this.flkty.selectCell(i), this.flkty.pausePlayer());
                    }
                    unload() {
                        this.flickity && this.flkty.destroy();
                    }
                    constructor(t) {
                        if (
                            ((this.section = t),
                            (this.container = t.container),
                            (this.slides = this.container.querySelector(lr)),
                            (this.firstText = this.container.querySelector(cr)),
                            (this.overlay = this.container.querySelector(hr)),
                            this.overlay && this.firstText)
                        ) {
                            const t = `-${this.firstText.clientHeight}px`;
                            this.container.style.setProperty("--timeshow-offset", t);
                        }
                        this.init();
                    }
                })(this);
            },
            onUnload() {
                "function" == typeof ar[this.id].unload && ar[this.id].unload();
            },
            onBlockSelect(t) {
                "function" == typeof ar[this.id].onBlockSelect && ar[this.id].onBlockSelect(t);
            },
        },
        ir,
        rr,
    ]);
    J("footer", [
        {
            onLoad() {
                var t = document.querySelector("[data-powered-link] a");
                t && t.setAttribute("rel", "noopener");
            },
        },
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", Ws);
    const pr = (t, e) => {
            const { el: i, elStyle: s, elHeight: o, rowsLimit: n, rowsWrapped: r, options: a } = t;
            let l = t.buffer,
                c = l;
            if (r === n + 1) return { ...t };
            const h = l;
            let d = r,
                u = o;
            return (
                (i.innerHTML = c = l.length ? `${l}${a.delimiter}${e}${a.replaceStr}` : `${e}${a.replaceStr}`),
                parseFloat(s.height) > parseFloat(o) && (d++, (u = s.height), d === n + 1)
                    ? ((i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`), { ...t, elHeight: u, rowsWrapped: d })
                    : ((i.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`), { ...t, buffer: c, elHeight: u, rowsWrapped: d })
            );
        },
        mr = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
    function yr(t) {
        const e = `data-popup-${t}`;
        r.init({
            openTrigger: e,
            disableScroll: !0,
            onShow: (t, e, i) => {
                i.preventDefault();
                const s = t.querySelector(mr);
                ot(t, { elementToFocus: s });
            },
            onClose: (t, e, i) => {
                i.preventDefault(), nt(), e.focus();
            },
        });
    }
    const fr = { color: "ash" },
        gr = "data-swatch";
    let vr = class extends HTMLElement {
        init() {
            this.setStyles();
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"));
        }
        constructor() {
            if ((super(), (this.element = this.querySelector(`[${gr}]`)), !this.element)) return;
            this.colorString = this.element.getAttribute(gr);
            new (class {
                getColor() {
                    return this.match;
                }
                init() {
                    return Oe({ json: window.theme.assets.swatches })
                        .then((t) => this.matchColors(t, this.settings.color))
                        .catch((t) => {
                            console.log("failed to load swatch colors script"), console.log(t);
                        });
                }
                matchColors(t, e) {
                    let i = "#E5E5E5",
                        s = null;
                    const o = window.theme.assets.base || "/",
                        n = e.toLowerCase().replace(/\s/g, ""),
                        r = t.colors;
                    if (r) {
                        const t = (t) => Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === n,
                            e = r.findIndex(t);
                        if (e > -1) {
                            const t = Object.values(r[e])[0],
                                n = t.toLowerCase();
                            n.includes(".jpg") || n.includes(".jpeg") || n.includes(".png") || n.includes(".svg") ? ((s = `${o}${t}`), (i = "#888888")) : (i = t);
                        }
                    }
                    return { color: this.settings.color, path: s, hex: i };
                }
                constructor(t = {}) {
                    (this.settings = { ...fr, ...t }), (this.match = this.init());
                }
            })({ color: this.colorString })
                .getColor()
                .then((t) => {
                    (this.colorMatch = t), this.init();
                });
        }
    };
    const wr = "data-store-availability-container",
        br = "[data-api-content]",
        Sr = "[data-pickup-drawer]",
        Er = "[data-pickup-drawer-open]",
        Lr = "[data-pickup-drawer-close]",
        kr = "[data-pickup-body]",
        Tr = "drawer--visible",
        Ar = "hide";
    let qr = {};
    const xr = {
        onLoad() {
            qr[this.id] = new (class {
                fetchPickupAvailability(t) {
                    const e = this.container.querySelector(`[${wr}]`);
                    if (!e) return;
                    let i = null;
                    t ? (null !== t.detail.variant ? (i = t.detail.variant.id) : e.classList.add(Ar)) : (i = e.getAttribute(wr)),
                        i &&
                            (e.classList.remove(Ar),
                            fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`)
                                .then(this.handleErrors)
                                .then((t) => t.text())
                                .then((t) => {
                                    const i = new DOMParser().parseFromString(t, "text/html").querySelector(br).innerHTML;
                                    (e.innerHTML = i),
                                        e.classList.toggle(Ar, 0 === i.trim().length),
                                        (this.drawer = this.container.querySelector(Sr)),
                                        (this.buttonDrawerOpen = this.container.querySelector(Er)),
                                        (this.buttonDrawerClose = this.container.querySelectorAll(Lr)),
                                        (this.drawerBody = this.container.querySelector(kr)),
                                        this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", () => this.openDrawer()),
                                        this.buttonDrawerClose.length &&
                                            this.buttonDrawerClose.forEach((t) => {
                                                t.addEventListener("click", () => this.closeDrawer());
                                            });
                                })
                                .catch((t) => {
                                    console.error(t);
                                }));
                }
                openDrawer() {
                    this.drawer && (this.drawer.classList.add(Tr), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                }
                closeDrawer() {
                    this.drawer && (this.drawer.classList.remove(Tr), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
                }
                handleErrors(t) {
                    return t.ok
                        ? t
                        : t.json().then(function (e) {
                              throw new Jt({ status: t.statusText, headers: t.headers, json: e });
                          });
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.drawer = null),
                        (this.buttonDrawerOpen = null),
                        (this.buttonDrawerClose = null),
                        (this.drawerBody = null),
                        this.fetchPickupAvailability(),
                        this.container.addEventListener("theme:variant:change", (t) => this.fetchPickupAvailability(t));
                }
            })(this);
        },
    };
    function Cr() {
        this.entries = [];
    }
    function Pr(t, e) {
        $r(t);
        var i = (function (t, e) {
            $r(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            return (
                $r(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e),
                t.variants.filter(function (t) {
                    return e.every(function (e, i) {
                        return t.options[i] === e;
                    });
                })[0] || null
            );
        })(t, i);
    }
    function $r(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (Cr.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (Cr.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var _r = '[name="id"]',
        Dr = '[name="selling_plan"]',
        Ir = '[name^="options"]',
        Mr = '[name="quantity"]',
        Hr = '[name^="properties"]';
    const Fr = { expires: 7, path: "/", domain: window.location.hostname };
    let Br = class {
        write(t) {
            document.cookie = `${this.options.name}=${t}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        read() {
            let t = [];
            const e = document.cookie.split("; ").find((t) => t.startsWith(this.options.name));
            if (-1 !== document.cookie.indexOf("; ") && e) {
                const e = document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.options.name))
                    .split("=")[1];
                null !== e && (t = e.split(","));
            }
            return t;
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        remove(t) {
            const e = this.read(),
                i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
        }
        constructor(t = {}) {
            this.options = { ...Fr, ...t };
        }
    };
    const Wr = 4,
        Or = 10,
        Nr = "[data-recently-viewed-products]",
        zr = "data-limit",
        Vr = "[data-recent-wrapper]",
        Rr = "[data-api-content]",
        jr = "data-product-class",
        Ur = "data-minimum",
        Jr = "hide",
        Yr = { expires: 90, name: "shopify_recently_viewed" },
        Kr = [],
        Xr = [];
    const Qr = {
            onLoad() {
                Kr[this.id] = new (class {
                    renderProducts() {
                        const t = this.cookie.read(),
                            e = [];
                        let i = 0;
                        if (t.length > 0) {
                            for (let s = 0; s < t.length; s++) {
                                const o = t[s];
                                if (Xr.includes(o)) continue;
                                const n = `${window.theme.routes.root_url}products/${o}?section_id=api-product-grid-item`;
                                if ((e.push(n), i++, i === this.howManyToShow || i === t.length - 1)) break;
                            }
                            if (e.length > 0 && e.length >= this.minimum) {
                                this.container.classList.remove(Jr);
                                const t = e.map((t) => fetch(t, { mode: "no-cors" }).then(this.handleErrors));
                                (this.productMarkups = []),
                                    Promise.allSettled(t)
                                        .then((t) =>
                                            Promise.all(
                                                t.map(async (t) => {
                                                    "fulfilled" === t.status && this.productMarkups.push(await t.value.text());
                                                })
                                            )
                                        )
                                        .then(() => {
                                            this.productMarkups.forEach((t) => {
                                                const e = document.createElement("div");
                                                (e.innerHTML = t), (this.wrapper.innerHTML += e.querySelector(Rr).innerHTML);
                                            });
                                        })
                                        .then(() => {
                                            ss(this.wrapper, !0), (this.slider = new Rn(this.container));
                                        });
                            }
                        }
                    }
                    handleErrors(t) {
                        return t.ok
                            ? t
                            : t.text().then(function (e) {
                                  throw new Jt({ status: t.statusText, headers: t.headers, text: e });
                              });
                    }
                    unload() {
                        this.slider && "function" == typeof this.slider.unload && this.slider.unload();
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.cookie = new Br(Yr)),
                            (this.wrapper = this.container.querySelector(Nr)),
                            (this.slider = null),
                            null !== this.wrapper &&
                                ((this.howManyToShow = parseInt(this.container.querySelector(Vr).getAttribute(zr)) || Wr),
                                (this.minimum = parseInt(this.container.querySelector(Vr).getAttribute(Ur))),
                                (this.classes = this.container.querySelector(Vr).getAttribute(jr).split(" ")),
                                this.renderProducts());
                    }
                })(this);
            },
            onUnload() {
                "function" == typeof Kr[this.id].unload && Kr[this.id].unload();
            },
        },
        Gr = "[data-product-form]",
        Zr = "data-option-position",
        ta = '[name^="options"], [data-popout-option]',
        ea = "data-value",
        ia = "sold-out",
        sa = "unavailable";
    const oa = "[data-section-id]",
        na = "data-product-slideshow",
        ra = "[data-add-to-cart]",
        aa = "[data-add-to-cart-text]",
        la = "[data-compare-price]",
        ca = "[data-compare-text]",
        ha = "[data-buttons-wrapper]",
        da = "[data-product-select]",
        ua = "[data-price-wrapper]",
        pa = "[data-button-price]",
        ma = "[data-product-json]",
        ya = "[data-product-price]",
        fa = "[data-product-unit-price]",
        ga = "[data-product-base]",
        va = "[data-product-unit]",
        wa = "data-enable-history-state",
        ba = "data-option-position",
        Sa = "[data-option-value]",
        Ea = "[data-recipient-checkbox]",
        La = "[data-recipient-input]",
        ka = "[data-subscription-watch-price]",
        Ta = "[data-subscription-selectors]",
        Aa = "[data-price-off]",
        qa = "[data-price-off-type]",
        xa = "[data-price-off-amount]",
        Ca = "[data-toggles-group]",
        Pa = "data-group-toggle",
        $a = "[data-plan-description]",
        _a = "[data-remaining-count]",
        Da = "[data-remaining-max]",
        Ia = "data-remaining-max",
        Ma = "[data-remaining-wrapper]",
        Ha = "[data-product-remaining-json]",
        Fa = "[data-product-preorder]",
        Ba = "[data-upsell-modal]",
        Wa = "hide",
        Oa = "variant--soldout",
        Na = "variant--unavailable",
        za = "product__price--sale",
        Va = "count-is-low",
        Ra = "count-is-in",
        ja = "count-is-out",
        Ua = "count-is-unavailable";
    let Ja = class extends HTMLElement {
        init() {
            let t = null;
            this.productJSON = null;
            const e = this.container.querySelector(ma);
            e && (t = e.innerHTML),
                t && this.container
                    ? ((this.productJSON = JSON.parse(t)),
                      this.linkForm(),
                      (this.sellout = new (class {
                          init() {
                              this.update();
                          }
                          update() {
                              this.getCurrentState(),
                                  this.optionElements.forEach((t) => {
                                      const e = t.value || t.getAttribute(ea),
                                          i = t.closest(`[${Zr}]`).getAttribute(Zr),
                                          s = parseInt(i, 10) - 1;
                                      let o = [...this.selections];
                                      o[s] = e;
                                      const n = this.productJSON.variants.find((t) => {
                                          let e = !0;
                                          for (let i = 0; i < o.length; i++) t.options[i] !== o[i] && (e = !1);
                                          return e;
                                      });
                                      t.classList.remove(ia, sa), void 0 === n ? t.classList.add(sa) : !1 === (null == n ? void 0 : n.available) && t.classList.add(ia);
                                  });
                          }
                          getCurrentState() {
                              for (var t of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1]);
                          }
                          constructor(t, e) {
                              (this.container = t),
                                  (this.productJSON = e),
                                  (this.form = this.container.querySelector(Gr)),
                                  (this.formData = new FormData(this.form)),
                                  (this.optionElements = this.form.querySelectorAll(ta)),
                                  this.productJSON && this.form && this.init();
                          }
                      })(this.container, this.productJSON)))
                    : console.warn("Missing product form or product JSON"),
                this.productJSON &&
                    new (class {
                        updateCookie() {
                            let t = this.cookie.read();
                            const e = t.indexOf(this.handle);
                            -1 === e ? (t.unshift(this.handle), (t = t.splice(0, Or))) : (t.splice(e, 1), t.unshift(this.handle)), this.cookie.write(t);
                        }
                        constructor(t) {
                            (this.handle = t), (this.cookie = new Br(Yr)), void 0 !== this.handle && (Xr.push(this.handle), this.updateCookie());
                        }
                    })(this.productJSON.handle);
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            (this.productForm = new (class {
                destroy() {
                    this._listeners.removeAll();
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, function (t) {
                        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                variant() {
                    const t = this.options();
                    return t.length ? Pr(this.product, t) : this.product.variants[0];
                }
                plan(t) {
                    let e = { allocation: null, group: null, detail: null };
                    const i = new FormData(this.form).get("selling_plan");
                    return (
                        i &&
                            t &&
                            (e.allocation = t.selling_plan_allocations.find(function (t) {
                                return t.selling_plan_id.toString() === i.toString();
                            })),
                        e.allocation &&
                            (e.group = this.product.selling_plan_groups.find(function (t) {
                                return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                            })),
                        e.group &&
                            (e.detail = e.group.selling_plans.find(function (t) {
                                return t.id.toString() === i.toString();
                            })),
                        e && e.allocation && e.detail && e.allocation ? e : null
                    );
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, function (t) {
                        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                    });
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                }
                getFormState() {
                    const t = this.variant();
                    return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                }
                _setIdInputValue(t) {
                    t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                }
                _onSubmit(t, e) {
                    (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant);
                }
                _onFormEvent(t) {
                    return void 0 === t
                        ? Function.prototype
                        : function (e) {
                              (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                          }.bind(this);
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                        function (t) {
                            return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                        }.bind(this)
                    );
                }
                _serializeInputValues(t, e) {
                    return t.reduce(function (t, i) {
                        return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                    }, []);
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t;
                }
                constructor(t, e, i) {
                    (this.element = t),
                        (this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
                        (this.product = this._validateProductObject(e)),
                        (this.variantElement = this.element.querySelector(_r)),
                        (i = i || {}),
                        (this._listeners = new Cr()),
                        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
                        (this.optionInputs = this._initInputs(Ir, i.onOptionChange)),
                        (this.planInputs = this._initInputs(Dr, i.onPlanChange)),
                        (this.quantityInputs = this._initInputs(Mr, i.onQuantityChange)),
                        (this.propertyInputs = this._initInputs(Hr, i.onPropertyChange));
                }
            })(this.container, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this) })),
                this.pushState(this.productForm.getFormState(), !0),
                this.subsToggleListeners();
        }
        onOptionChange(t) {
            this.pushState(t.dataset);
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset);
        }
        onQuantityChange(t) {
            const e = t.dataset;
            (this.productState = this.setProductState(e)), this.updateButtonPrices(e);
        }
        pushState(t, e = !1) {
            var i;
            (this.productState = this.setProductState(t)),
                this.updateProductImage(t),
                this.updateAddToCartState(t),
                this.updateProductPrices(t),
                this.updateSaleText(t),
                this.updateSubscriptionText(t),
                this.updateLegend(t),
                this.updateRemaining(t),
                this.fireHookEvent(t),
                null === (i = this.sellout) || void 0 === i || i.update(t),
                this.enableHistoryState && !e && this.updateHistoryState(t);
        }
        updateAddToCartState(t) {
            const e = t.variant;
            let i = theme.strings.addToCart;
            const s = this.outerWrapper.querySelectorAll(ua),
                o = this.container.querySelector(ha),
                n = o.querySelectorAll(ra),
                r = o.querySelectorAll(aa);
            if (
                (this.isPreOrder && (i = theme.strings.preOrder),
                s.length &&
                    e &&
                    s.forEach((t) => {
                        t.classList.remove(Wa);
                    }),
                n.length &&
                    n.forEach((t) => {
                        e && e.available ? (t.disabled = !1) : (t.disabled = !0);
                    }),
                r.length &&
                    r.forEach((t) => {
                        e ? (e.available ? (t.innerHTML = i) : (t.innerHTML = theme.strings.soldOut)) : (t.innerHTML = theme.strings.unavailable);
                    }),
                o)
            )
                if (e) {
                    e.available ? o.classList.remove(Oa, Na) : (o.classList.add(Oa), o.classList.remove(Na));
                    const t = o.querySelector(da);
                    t && (t.value = e.id);
                } else o.classList.add(Na), o.classList.remove(Oa);
        }
        updateLegend(t) {
            const e = t.variant;
            if (e) {
                this.container.querySelectorAll(Sa).forEach((t) => {
                    const i = t.closest(`[${ba}]`);
                    if (i) {
                        const s = i.getAttribute(ba),
                            o = parseInt(s, 10) - 1,
                            n = e.options[o];
                        t.innerHTML = n;
                    }
                });
            }
        }
        updateHistoryState(t) {
            const e = t.variant,
                i = t.plan,
                s = window.location.href;
            if (e && s.includes("/product")) {
                const t = new window.URL(s),
                    o = t.searchParams;
                o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                const n = t.toString();
                window.history.replaceState({ path: n }, "", n);
            }
        }
        updateRemaining(t) {
            const e = t.variant;
            if (e && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                const t = this.remainingJSON[e.id];
                t && t <= this.remainingMaxInt && t > 0
                    ? (this.remainingWrapper.classList.remove(Ra, ja, Ua), this.remainingWrapper.classList.add(Va), (this.remainingCount.innerHTML = t))
                    : this.productState.soldOut
                    ? (this.remainingWrapper.classList.remove(Va, Ra, Ua), this.remainingWrapper.classList.add(ja))
                    : this.productState.available && (this.remainingWrapper.classList.remove(Va, ja, Ua), this.remainingWrapper.classList.add(Ra));
            } else this.remainingWrapper && (this.remainingWrapper.classList.remove(Ra, ja, Va), this.remainingWrapper.classList.add(Ua));
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            this.container.querySelectorAll(Ca).forEach((t) => {
                t.addEventListener(
                    "change",
                    function (t) {
                        const e = t.target.value.toString(),
                            i = this.container.querySelector(`[${Pa}="${e}"]`),
                            s = this.container.querySelectorAll(`[${Pa}]`);
                        if (i) {
                            i.classList.remove(Wa);
                            const t = i.querySelector('[name="selling_plan"]');
                            (t.checked = !0), t.dispatchEvent(new Event("change"));
                        }
                        s.forEach((t) => {
                            if (t !== i) {
                                t.classList.add(Wa);
                                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                    (t.checked = !1), t.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(t) {
            this.productState.planSale
                ? this.updateSaleTextSubscription(t)
                : this.productState.onSale
                ? this.updateSaleTextStandard(t)
                : this.priceOffWrap.forEach((t) => {
                      t.classList.add(Wa);
                  });
        }
        updateSaleTextStandard(t) {
            if (0 === this.priceOffType.length) return;
            this.priceOffType.forEach((t) => {
                t.innerHTML = window.theme.strings.sale || "sale";
            });
            const e = t.variant;
            if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                const t = (e.compare_at_price - e.price) / e.compare_at_price,
                    i = Math.floor(100 * t);
                this.priceOffAmount.forEach((t) => {
                    t.innerHTML = `${i}%`;
                });
            } else {
                const t = e.compare_at_price - e.price;
                this.priceOffAmount.forEach((e) => {
                    e.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(t, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(t, theme.moneyFormat);
                });
            }
            this.priceOffWrap.forEach((t) => {
                t.classList.remove(Wa);
            });
        }
        updateSaleTextSubscription(t) {
            this.priceOffType.forEach((t) => {
                t.innerHTML = window.theme.strings.subscription || "subscripton";
            });
            const e = t.variant,
                s = t.plan.detail.price_adjustments[0],
                o = s.value;
            s && "percentage" === s.value_type
                ? this.priceOffAmount.forEach((t) => {
                      t.innerHTML = `${o}%`;
                  })
                : s && "price" === s.value_type
                ? this.priceOffAmount.forEach((t) => {
                      t.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(e.price - s.value, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(e.price - s.value, theme.moneyFormat);
                  })
                : this.priceOffAmount.forEach((t) => {
                      t.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(o, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(o, theme.moneyFormat);
                  }),
                this.priceOffWrap.forEach((t) => {
                    t.classList.remove(Wa);
                });
        }
        updateSubscriptionText(t) {
            t.plan && this.planDescription.length > 0 && null !== t.plan.detail.description
                ? this.planDescription.forEach((e) => {
                      (e.innerHTML = t.plan.detail.description), e.classList.remove(Wa);
                  })
                : this.planDescription.length > 0 &&
                  this.planDescription.forEach((t) => {
                      t.classList.add(Wa);
                  });
        }
        getPrices(t) {
            const e = t.variant,
                i = t.plan;
            let s = "",
                o = "";
            return (
                this.productState.available && ((s = e.compare_at_price), (o = e.price)),
                this.productState.hasPlan && (o = i.allocation.price),
                this.productState.planSale && ((s = i.allocation.compare_at_price), (o = i.allocation.price)),
                { price: o, comparePrice: s }
            );
        }
        updateButtonPrices(t) {
            const e = this.container.querySelectorAll(pa),
                { price: s } = this.getPrices(t);
            e.length &&
                e.forEach((e) => {
                    const o = t.quantity * s;
                    e.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(o, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(o, theme.moneyFormat);
                });
        }
        updateProductPrices(t) {
            const e = t.variant,
                s = this.outerWrapper.querySelectorAll(ua),
                o = this.outerWrapper.querySelectorAll(pa),
                { price: n, comparePrice: r } = this.getPrices(t);
            s.forEach((t) => {
                const s = t.querySelector(la),
                    o = t.querySelector(ya),
                    a = t.querySelector(ca);
                s &&
                    (this.productState.onSale || this.productState.planSale ? (s.classList.remove(Wa), a.classList.remove(Wa), o.classList.add(za)) : (s.classList.add(Wa), a.classList.add(Wa), o.classList.remove(za)),
                    (s.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(r, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(r, theme.moneyFormat))),
                    o && (o.innerHTML = e ? (theme.settings.currency_code_enable ? i.formatMoney(n, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(n, theme.moneyFormat)) : "&nbsp;");

                        try{
              o.classList.remove("wpd-processed");
              o.setAttribute("data-wpd-variant-compare-at-price",e.compare_at_price == null ? "":e.compare_at_price);
              o.setAttribute("data-wpd-variant-price",e.price);
              o.setAttribute("data-wpd-variant-id",e.id);
              o.setAttribute("data-wpd-product-handle",window.wpdExtensionIsProductPage.handle);
              }catch(erroe){}
            }),
                o.length &&
                    o.forEach((e) => {
                        const s = t.quantity * n;
                        e.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(s, theme.moneyFormat) + ` ${theme.currencyCode}` : i.formatMoney(s, theme.moneyFormat);
                    }),
                this.hasUnitPricing.length > 0 && this.updateProductUnits(t);
          console.log("data price", s)
    

          
        }
        updateProductUnits(t) {
            const e = t.variant,
                s = t.plan;
            let o = null;
            if ((e && e.unit_price && (o = e.unit_price), s && s.allocation && s.allocation.unit_price && (o = s.allocation.unit_price), o)) {
                const t = this.getBaseUnit(e),
                    s = i.formatMoney(o, theme.moneyFormat);
                this.outerWrapper.querySelectorAll(fa).forEach((t) => {
                    t.innerHTML = theme.settings.currency_code_enable ? s + ` ${theme.currencyCode}` : s;
                }),
                    this.outerWrapper.querySelectorAll(ga).forEach((e) => {
                        e.innerHTML = t;
                    }),
                    this.outerWrapper.querySelectorAll(va).forEach((t) => {
                        ss(t);
                    });
            } else
                this.outerWrapper.querySelectorAll(va).forEach((t) => {
                    os(t);
                });
        }
        handleCheckboxChange() {
            const t = this.recipientCheckbox.checked;
            this.recipientInputs.forEach((e) => {
                e.disabled = !t;
            });
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
        }
        setProductState(t) {
            const e = t.variant,
                i = t.plan,
                s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
            return (
                !e || (e.requires_selling_plan && !i)
                    ? (s.available = !1)
                    : (e.available || (s.soldOut = !0),
                      e.compare_at_price > e.price && (s.onSale = !0),
                      e.unit_price && (s.showUnitPrice = !0),
                      this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0),
                      i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0))),
                s
            );
        }
        updateProductImage(t) {
            const e = t.variant;
            !this.slideshow && this.outerSection && (this.slideshow = this.outerSection.querySelector(`[${na}="${this.productJSON.handle}"]`)),
                !this.slideshow && this.upsell && (this.slideshow = this.upsell.querySelector(`[${na}]`)),
                this.slideshow && e && e.featured_media && e.featured_media.id && this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: e.featured_media.id } }));
        }
        constructor() {
            var t;
            if (
                (super(),
                (this.container = this),
                (this.outerSection = this.container.closest(oa)),
                (this.upsell = this.container.closest(Ba)),
                (this.enableHistoryState = "true" === (null === (t = this.outerSection) || void 0 === t ? void 0 : t.getAttribute(wa))),
                (this.outerWrapper = this.upsell ? this.upsell : this.container.closest(oa) || this.container),
                (this.priceOffWrap = this.outerWrapper.querySelectorAll(Aa)),
                (this.priceOffAmount = this.outerWrapper.querySelectorAll(xa)),
                (this.priceOffType = this.outerWrapper.querySelectorAll(qa)),
                (this.hasUnitPricing = this.outerWrapper.querySelectorAll(va)),
                (this.subSelectors = this.container.querySelector(Ta)),
                (this.subPrices = this.container.querySelector(ka)),
                (this.planDescription = this.container.querySelectorAll($a)),
                (this.isPreOrder = this.container.querySelector(Fa)),
                (this.sellout = null),
                (this.productForm = null),
                (this.remainingWrapper = this.container.querySelector(Ma)),
                this.remainingWrapper)
            ) {
                const t = this.container.querySelector(Da);
                (this.remainingMaxInt = parseInt(t.getAttribute(Ia), 10)),
                    (this.remainingCount = this.container.querySelector(_a)),
                    (this.remainingJSONWrapper = this.container.querySelector(Ha)),
                    (this.remainingJSON = null),
                    this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON");
            }
            Ti(this.container),
                (this.recipientCheckbox = this.container.querySelector(Ea)),
                this.recipientCheckbox && ((this.recipientInputs = this.container.querySelectorAll(La)), this.recipientCheckbox.addEventListener("change", this.handleCheckboxChange.bind(this))),
                this.init();
        }
    };
    const Ya = "[data-product-slideshow]",
        Ka = ".product__wrapper",
        Xa = "[data-form-wrapper]",
        Qa = '[data-header-sticky="true"]',
        Ga = "[data-header-height]",
        Za = "data-product-sticky-enabled",
        tl = "is-sticky";
    window.theme.variables = { productPageSticky: !1 };
    const el = {};
    const il = {
            onLoad() {
                el[this.id] = new (class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                            this.formWrapper.addEventListener("theme:form:sticky", (t) => {
                                this.removeAnimationFrame(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t)));
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    scrollEvents(t) {
                        (this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down), this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
                    }
                    resizeEvents(t) {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.initSticky();
                    }
                    stickyScrollCheck() {
                        const t = this.container.querySelector(`${Ka} ${Xa}`);
                        if (t)
                            if (ks()) {
                                const e = this.container.querySelector(Xa),
                                    i = this.container.querySelector(Ya);
                                if (!e || !i) return;
                                e.offsetHeight < i.offsetHeight ? ((theme.variables.productPageSticky = !0), t.classList.add(tl)) : ((theme.variables.productPageSticky = !1), t.classList.remove(tl));
                            } else (theme.variables.productPageSticky = !1), t.classList.remove(tl);
                    }
                    calculateStickyPosition(t = null) {
                        if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrame();
                        const e = Boolean(t && t.detail),
                            i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            s = this.formWrapper.offsetHeight,
                            o = window.innerHeight - s - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n),
                            this.stickyFormLoad &&
                                (document.querySelector(Qa) && document.querySelector(Ga)
                                    ? (this.stickyDefaultTop = parseInt(document.querySelector(Ga).getBoundingClientRect().height))
                                    : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                                (this.stickyScrollTop = this.stickyDefaultTop)),
                            (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop));
                        const r = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * r),
                            this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (i && this.onChangeCounter <= 10) || (i && this.stickyFormLastHeight !== s) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (i && (this.onChangeCounter += 1), i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                                : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.stickyFormLastHeight = s);
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute(Za)),
                            (this.formWrapper = this.container.querySelector(Xa)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            setTimeout(() => {
                                this.init();
                            }, 50);
                    }
                })(this);
            },
            onUnload() {
                el[this.id].onUnload();
            },
        },
        sl = "[data-product-slideshow]",
        ol = "[data-product-image]",
        nl = "[data-zoom-button]",
        rl = "[data-zoom-wrapper]",
        al = "[data-media-id]",
        ll = "data-media-id";
    let cl = class extends HTMLElement {
        connectedCallback() {
            fetch(this.dataset.url)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const i = e.querySelector("[data-api-content]");
                    i && (this.innerHTML = i.innerHTML);
                    const s = this.closest("[data-product-complimentary-loaded]");
                    s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded");
                    this.querySelectorAll("[data-add-action-wrapper]").forEach((t) => {
                        new ci(t);
                    });
                })
                .catch((t) => {
                    console.error(t);
                });
        }
        constructor() {
            super();
        }
    };
    const hl = "[data-share-url]",
        dl = "data-section-type",
        ul = "[data-share-details]",
        pl = "[data-share-summary]",
        ml = "[data-share-copy]",
        yl = "[data-share-button]",
        fl = "[data-close-button]",
        gl = "[data-success-message]",
        vl = "[data-share-holder]",
        wl = "is-hidden";
    let bl = class extends HTMLElement {
        init() {
            navigator.share
                ? (this.mainDetailsToggle.setAttribute("hidden", ""),
                  this.shareButton.classList.remove(wl),
                  this.shareButton.addEventListener("click", () => {
                      navigator.share({ url: this.urlToShare, title: document.title });
                  }))
                : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)),
                  this.mainDetailsToggle.addEventListener("focusout", () => {
                      setTimeout(() => {
                          this.contains(document.activeElement) || this.close();
                      });
                  }),
                  this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)),
                  this.closeButton.addEventListener("click", this.close.bind(this)),
                  this.container.addEventListener("keyup", this.keyboardEvents.bind(this)));
        }
        updateShareLink() {
            "product" == this.container.getAttribute(dl) &&
                this.container.addEventListener("theme:variant:change", (t) => {
                    (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`), this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`);
                });
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(wl), (this.successMessage.textContent = ""), this.closeButton.classList.add(wl), this.shareCopy.focus());
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then(() => {
                this.successMessage.classList.remove(wl), (this.successMessage.textContent = theme.strings.successMessage), this.closeButton.classList.remove(wl), this.closeButton.focus();
            });
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1);
        }
        keyboardEvents(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this.mainDetailsToggle.focus(), this.close());
        }
        constructor() {
            super(),
                (this.container = this.closest(`[${dl}]`)),
                (this.mainDetailsToggle = this.querySelector(ul)),
                (this.shareButton = this.querySelector(yl)),
                (this.shareCopy = this.querySelector(ml)),
                (this.shareSummary = this.querySelector(pl)),
                (this.closeButton = this.querySelector(fl)),
                (this.successMessage = this.querySelector(gl)),
                (this.shareHolder = this.querySelector(vl)),
                (this.urlInput = this.querySelector(hl)),
                (this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href),
                this.init(),
                this.updateShareLink();
        }
    };
    const Sl = "videoid",
        El = "[data-player]",
        Ll = "data-enable-video-looping",
        kl = "lty-playbtn",
        Tl = "lyt-visually-hidden",
        Al = "lyt-activated";
    let ql = class t extends HTMLElement {
        connectedCallback() {
            this.videoId = this.getAttribute(Sl);
            let e = this.querySelector(`.${kl}`);
            if (
                ((this.playLabel = (e && e.textContent.trim()) || this.getAttribute("playlabel") || "Play"),
                this.style.backgroundImage || (this.style.backgroundImage = `url("https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg")`),
                e || ((e = document.createElement("button")), (e.type = "button"), e.classList.add(kl), this.append(e)),
                !e.textContent)
            ) {
                const t = document.createElement("span");
                (t.className = Tl), (t.textContent = this.playLabel), e.append(t);
            }
            this.addEventListener("pointerover", t.warmConnections, { once: !0 }), this.addEventListener("click", this.addIframe);
        }
        static addPrefetch(t, e, i) {
            const s = document.createElement("link");
            (s.rel = t), (s.href = e), i && (s.as = i), document.head.append(s);
        }
        static warmConnections() {
            t.preconnected ||
                (t.addPrefetch("preconnect", "https://www.youtube-nocookie.com"),
                t.addPrefetch("preconnect", "https://www.google.com"),
                t.addPrefetch("preconnect", "https://googleads.g.doubleclick.net"),
                t.addPrefetch("preconnect", "https://static.doubleclick.net"),
                (t.preconnected = !0));
        }
        addIframe(t) {
            if (this.classList.contains(Al)) return;
            t.preventDefault(), this.classList.add(Al);
            const e = this.closest(El);
            if (e) {
                const t = e.dataset.player,
                    i = !!this.hasAttribute(Ll) && "true" === this.getAttribute(Ll);
                Jn(t, { autoplay: !0, playlist: this.videoId, loop: i });
            } else {
                const t = new URLSearchParams(this.getAttribute("params") || []);
                t.append("autoplay", "1");
                const e = document.createElement("iframe");
                (e.width = 560),
                    (e.height = 315),
                    (e.title = this.playLabel),
                    (e.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"),
                    (e.allowFullscreen = !0),
                    (e.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(this.videoId)}?${t.toString()}`),
                    this.append(e),
                    e.focus();
            }
        }
    };
    const xl = { scrollbar: "data-scrollbar-slider", scrollbarArrowPrev: "[data-scrollbar-arrow-prev]", scrollbarArrowNext: "[data-scrollbar-arrow-next]" },
        Cl = { hide: "is-hidden" },
        Pl = { delay: 200 };
    const $l = "body",
        _l = "[data-related-section]",
        Dl = "[data-tabs-holder]",
        Il = "data-tab",
        Ml = "data-tab-index",
        Hl = "data-block-id",
        Fl = ".tabs > button",
        Bl = ".tab-link",
        Wl = ".tab-link__recent",
        Ol = ".tab-content",
        Nl = "[data-scrollbar]",
        zl = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Vl = "current",
        Rl = "hide",
        jl = "alt",
        Ul = "focus-enabled",
        Jl = {};
    const Yl = {
            onLoad() {
                Jl[this.id] = [];
                this.container.querySelectorAll(Dl).forEach((t) => {
                    Jl[this.id].push(
                        new (class {
                            init() {
                                const t = this.container,
                                    e = t.querySelectorAll(Fl),
                                    i = t.querySelector(`${Bl}-0`),
                                    s = t.querySelector(`${Ol}-0`);
                                s && s.classList.add(Vl),
                                    i && i.classList.add(Vl),
                                    this.checkVisibleTabLinks(),
                                    this.container.addEventListener("tabs:checkRecentTab", () => this.checkRecentTab()),
                                    this.container.addEventListener("tabs:hideRelatedTab", () => this.hideRelatedTab()),
                                    e.length &&
                                        e.forEach((e) => {
                                            const i = parseInt(e.getAttribute(Il)),
                                                s = t.querySelector(`${Ol}-${i}`);
                                            e.addEventListener("click", () => {
                                                this.tabChange(e, s);
                                            }),
                                                e.addEventListener("keyup", (t) => {
                                                    (t.which !== window.theme.keyboardKeys.SPACE && t.which !== window.theme.keyboardKeys.ENTER) ||
                                                        !this.body.classList.contains(Ul) ||
                                                        (this.tabChange(e, s), s.querySelector(zl) && ot(s, { elementToFocus: s.querySelector(zl) }));
                                                }),
                                                s.addEventListener("keyup", (t) => {
                                                    t.which === window.theme.keyboardKeys.ESCAPE && this.body.classList.contains(Ul) && (nt(), e.focus());
                                                });
                                        });
                            }
                            tabChange(t, e) {
                                this.container.querySelector(`${Fl}.${Vl}`).classList.remove(Vl),
                                    this.container.querySelector(`${Ol}.${Vl}`).classList.remove(Vl),
                                    t.classList.add(Vl),
                                    e.classList.add(Vl),
                                    t.classList.contains(Rl) && e.classList.add(Rl),
                                    this.checkVisibleTabLinks(),
                                    this.container.dispatchEvent(new CustomEvent("theme:tab:change")),
                                    this.container.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "tab" } }));
                            }
                            initNativeScrollbar() {
                                this.scrollbarHolder.length &&
                                    this.scrollbarHolder.forEach((t) => {
                                        new (class {
                                            init() {
                                                this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events());
                                            }
                                            resize() {
                                                document.addEventListener("theme:resize", () => {
                                                    this.toggleNextArrow();
                                                });
                                            }
                                            events() {
                                                this.arrowNext.addEventListener("click", (t) => {
                                                    t.preventDefault(), this.goToNext();
                                                }),
                                                    this.arrowPrev.addEventListener("click", (t) => {
                                                        t.preventDefault(), this.goToPrev();
                                                    }),
                                                    this.scrollbar.addEventListener("scroll", () => {
                                                        this.togglePrevArrow(), this.toggleNextArrow();
                                                    });
                                            }
                                            goToNext() {
                                                const t = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
                                                this.move(t), this.arrowPrev.classList.remove(Cl.hide), this.toggleNextArrow();
                                            }
                                            goToPrev() {
                                                const t = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
                                                this.move(t), this.arrowNext.classList.remove(Cl.hide), this.togglePrevArrow();
                                            }
                                            toggleNextArrow() {
                                                setTimeout(() => {
                                                    this.arrowNext.classList.toggle(Cl.hide, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
                                                }, Pl.delay);
                                            }
                                            togglePrevArrow() {
                                                setTimeout(() => {
                                                    this.arrowPrev.classList.toggle(Cl.hide, this.scrollbar.scrollLeft <= 0);
                                                }, Pl.delay);
                                            }
                                            scrollToVisibleElement() {
                                                [].forEach.call(this.scrollbar.children, (t) => {
                                                    t.addEventListener("click", (e) => {
                                                        e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
                                                    });
                                                });
                                            }
                                            move(t) {
                                                this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
                                            }
                                            constructor(t) {
                                                (this.scrollbar = t),
                                                    (this.arrowNext = this.scrollbar.parentNode.querySelector(xl.scrollbarArrowNext)),
                                                    (this.arrowPrev = this.scrollbar.parentNode.querySelector(xl.scrollbarArrowPrev)),
                                                    this.init(),
                                                    this.resize(),
                                                    this.scrollbar.hasAttribute(xl.scrollbar) && this.scrollToVisibleElement();
                                            }
                                        })(t);
                                    });
                            }
                            checkVisibleTabLinks() {
                                const t = this.container.querySelectorAll(Fl),
                                    e = this.container.querySelectorAll(`${Bl}.${Rl}`);
                                t.length - e.length < 2 ? this.container.classList.add(jl) : this.container.classList.remove(jl);
                            }
                            checkRecentTab() {
                                const t = this.container.querySelector(Wl);
                                if (t) {
                                    t.classList.remove(Rl);
                                    const e = parseInt(t.getAttribute(Il)),
                                        i = this.container.querySelector(`${Ol}[${Ml}="${e}"]`);
                                    i && i.classList.remove(Rl), this.checkVisibleTabLinks(), this.initNativeScrollbar();
                                }
                            }
                            hideRelatedTab() {
                                const t = this.container.querySelector(_l);
                                if (!t) return;
                                const e = t.closest(`${Ol}.${Vl}`);
                                if (!e) return;
                                const i = parseInt(e.getAttribute(Ml)),
                                    s = this.container.querySelectorAll(Fl);
                                if (s.length > i) {
                                    const t = s[i].nextSibling;
                                    t && (s[i].classList.add(Rl), t.dispatchEvent(new Event("click")), this.initNativeScrollbar());
                                }
                            }
                            onBlockSelect(t) {
                                const e = this.container.querySelector(`${Bl}[${Hl}="${t.detail.blockId}"]`);
                                e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                            }
                            constructor(t) {
                                (this.container = t), (this.body = document.querySelector($l)), this.container && ((this.scrollbarHolder = this.container.querySelectorAll(Nl)), this.init(), this.initNativeScrollbar());
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                Jl[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
        },
        Kl = "data-image-filter",
        Xl = "[data-product-slideshow]",
        Ql = "[data-product-thumbs]",
        Gl = "[data-slideshow-thumbnail]",
        Zl = "[data-media-slide]",
        tc = "hide",
        ec = "flickity-enabled";
    const ic = "[data-product-form]",
        sc = "[data-product-json]",
        oc = "[data-zoom-button]",
        nc = "[data-truncated-holder]",
        rc = "[data-truncated-button]",
        ac = "[data-truncated-content]",
        lc = "data-truncated-content",
        cc = "is-expanded",
        hc = "is-visible",
        dc = [];
    const uc = {
        onLoad() {
            dc[this.id] = new (class {
                init() {
                    var t, e;
                    (this.zoomEnabled = null !== this.container.querySelector(oc)),
                        this.zoomEnabled &&
                            ((t = this.container),
                            (e = this.product),
                            Oe({ url: window.theme.assets.photoswipe })
                                .then(() => {
                                    const i = window.themePhotoswipe.PhotoSwipe.default,
                                        s = window.themePhotoswipe.PhotoSwipeUI.default;
                                    t.querySelectorAll(nl).forEach((o) => {
                                        o.addEventListener("click", (o) => {
                                            const n = t.querySelector(rl),
                                                r = o.target.closest(al).getAttribute(ll).toString(),
                                                a = [];
                                            for (let t = 0; t < e.media.length; t++) "image" === e.media[t].media_type && (a[a.length] = { src: e.media[t].src, w: e.media[t].width, h: e.media[t].height, id: e.media[t].id });
                                            const l = {
                                                index: a.findIndex((t) => t.id.toString() === r),
                                                showHideOpacity: !0,
                                                showAnimationDuration: 150,
                                                hideAnimationDuration: 250,
                                                bgOpacity: 1,
                                                spacing: 0,
                                                allowPanToNext: !1,
                                                maxSpreadZoom: 3,
                                                history: !1,
                                                loop: !0,
                                                pinchToClose: !1,
                                                modal: !1,
                                                closeOnScroll: !1,
                                                closeOnVerticalDrag: !0,
                                                getDoubleTapZoom: function (t, e) {
                                                    return t ? 1.67 : e.initialZoomLevel < 0.7 ? 1 : 1.3;
                                                },
                                                getThumbBoundsFn: function () {
                                                    let e = t.querySelector(sl);
                                                    e || (e = t.querySelector(ol));
                                                    const i = window.pageYOffset || document.documentElement.scrollTop,
                                                        s = e.getBoundingClientRect();
                                                    return { x: s.left, y: s.top + i, w: s.width };
                                                },
                                            };
                                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                            let c = null;
                                            const h = new i(n, s, a, l);
                                            (h.updateSize = new Proxy(h.updateSize, { apply: (t) => c !== window.innerWidth && (t(l), (c = window.innerWidth)) })),
                                                h.init(),
                                                h.listen("close", function () {
                                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                                });
                                        });
                                    });
                                })
                                .catch((t) => console.error(t))),
                        this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate));
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(hc)) return;
                    const t = this.truncateElement.querySelectorAll("style");
                    t.length &&
                        t.forEach((t) => {
                            this.truncateElementHolder.prepend(t);
                        });
                    const e = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(lc),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(e);
                    const o = this.truncateElement.nextElementSibling;
                    o.classList.add(i),
                        o.removeAttribute(lc),
                        ss(o),
                        ((t = "", e = 1, i = {}) => {
                            const s = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...i },
                                o = t && (t instanceof NodeList ? t : 1 === t.nodeType ? [t] : document.querySelectorAll(t));
                            for (let t = 0; t < o.length; t++) {
                                const i = o[t],
                                    n = /<!--[\s\S]*?-->/g,
                                    r = i.innerHTML.replace(n, "").split(s.delimiter);
                                i.innerHTML = "";
                                const a = window.getComputedStyle(i);
                                r.reduce(pr, { el: i, buffer: i.innerHTML, elStyle: a, elHeight: 0, rowsLimit: e, rowsWrapped: 0, options: s });
                            }
                        })(o, 5, { replaceStr: "", delimiter: " " }),
                        os(o),
                        this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(cc) : (o.remove(), this.truncateElementHolder.classList.remove(cc)),
                        this.toggleTruncatedContent(this.truncateElementHolder);
                }
                toggleTruncatedContent(t) {
                    const e = t.querySelector(rc);
                    e &&
                        e.addEventListener("click", (e) => {
                            e.preventDefault(), t.classList.remove(cc), t.classList.add(hc);
                        });
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"));
                }
                onBlockDeselect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"));
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate);
                }
                constructor(t) {
                    (this.section = t),
                        (this.id = t.id),
                        (this.container = t.container),
                        (this.settings = t.settings),
                        (this.productFormElement = this.container.querySelector(ic)),
                        yr(this.id),
                        (this.media = new Qe(t)),
                        new (class {
                            listen() {
                                this.container.addEventListener("theme:variant:change", (t) => {
                                    var e;
                                    (this.variantImage = null === (e = t.detail.variant) || void 0 === e ? void 0 : e.featured_image), this.filterImages();
                                });
                            }
                            filterImages() {
                                if (null === this.variantImage || void 0 === this.variantImage) return this.resetImages(), void this.refreshSliders();
                                this.variantImage && null !== this.variantImage.alt ? ((this.variantImageAlt = this.variantImage.alt.split("#")[1]), this.showImages()) : this.resetImages(), this.refreshSliders();
                            }
                            resetImages() {
                                this.thumbs.forEach((t) => t.classList.remove(tc)), this.slides.forEach((t) => t.classList.remove(tc));
                            }
                            showImages() {
                                this.thumbs.forEach((t) => {
                                    "" === t.getAttribute(Kl) || t.getAttribute(Kl) === this.variantImageAlt ? t.classList.remove(tc) : t.classList.add(tc);
                                }),
                                    this.slides.forEach((t) => {
                                        "" === t.getAttribute(Kl) || t.getAttribute(Kl) === this.variantImageAlt ? t.classList.remove(tc) : t.classList.add(tc);
                                    });
                            }
                            refreshSliders() {
                                if (null !== this.slider && this.slider.classList.contains(ec)) {
                                    const t = e.data(this.slider);
                                    void 0 !== t && t.reloadCells();
                                }
                                if (null !== this.thumbSlider && this.thumbSlider.classList.contains(ec)) {
                                    const t = a.data(this.thumbSlider);
                                    void 0 !== t && t.reloadCells();
                                }
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = t.container),
                                    (this.slider = this.container.querySelector(Xl)),
                                    (this.thumbSlider = this.container.querySelector(Ql)),
                                    (this.thumbs = this.container.querySelectorAll(Gl)),
                                    (this.slides = this.container.querySelectorAll(Zl)),
                                    (this.variantImage = null),
                                    this.listen();
                            }
                        })(t);
                    const i = this.container.querySelector(sc);
                    i && "" !== i.innerHTML
                        ? ((this.product = JSON.parse(i.innerHTML)),
                          (this.truncateElementHolder = this.container.querySelector(nc)),
                          (this.truncateElement = this.container.querySelector(ac)),
                          (this.resizeEventTruncate = () => this.truncateText()),
                          this.init())
                        : console.error("Missing product JSON");
                }
            })(this);
        },
        onUnload() {
            "function" == typeof dc[this.id].unload && dc[this.id].unload();
        },
        onBlockSelect(t) {
            "function" == typeof dc[this.id].onBlockSelect && dc[this.id].onBlockSelect(t);
        },
        onBlockDeselect(t) {
            "function" == typeof dc[this.id].onBlockDeselect && dc[this.id].onBlockDeselect(t);
        },
    };
    J("product", [uc, xr, hi, il, yo, Yl, un]),
        customElements.get("product-form") || customElements.define("product-form", Ja),
        customElements.get("product-complimentary") || customElements.define("product-complimentary", cl),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", vr),
        customElements.get("popout-select") || customElements.define("popout-select", Ws),
        customElements.get("upsell-product") || customElements.define("upsell-product", bi),
        customElements.get("share-button") || customElements.define("share-button", bl),
        customElements.get("lite-youtube") || customElements.define("lite-youtube", ql);
    J("related", {
        onLoad: function () {
            const t = this.container.parentElement,
                e = this.container.getAttribute("data-product-id"),
                i = this.container.getAttribute("data-limit"),
                s = this.container.getAttribute("data-section-id"),
                o = `${window.theme.routes.product_recommendations_url || "/recommendations/products/"}?section_id=${s}&limit=${i}&product_id=${e}`;
            (t.style.display = "none"),
                fetch(o)
                    .then((t) => t.text())
                    .then((e) => {
                        const i = document.createElement("div");
                        (i.innerHTML = e),
                            (t.innerHTML = i.querySelector("[data-related-section]").innerHTML),
                            Yt(t),
                            setTimeout(() => {
                                new Rn(t);
                            }, 600);
                    })
                    .catch((t) => console.log(t));
        },
    }),
        J("reviews", [jn, rr]);
    const pc = "[data-scroll-down]";
    const mc = {
            onLoad() {
                this.scrollButton = new (class {
                    init() {
                        const t = this.wrapper.querySelectorAll(pc);
                        t &&
                            t.forEach((t) => {
                                t.addEventListener("click", this.scroll.bind(this));
                            });
                    }
                    scroll() {
                        const t = this.wrapper.offsetTop + this.wrapper.clientHeight;
                        window.scroll({ top: t, left: 0, behavior: "smooth" });
                    }
                    constructor(t) {
                        (this.wrapper = t), this.init();
                    }
                })(this.container);
            },
            onUnload: function () {
                delete this.scrollButton;
            },
        },
        yc = [],
        fc = "[data-slideshow-wrapper]",
        gc = "data-slideshow-speed",
        vc = "data-slideshow-autoplay",
        wc = "data-slideshow-slides",
        bc = "[slide-custom-prev]",
        Sc = "[slide-custom-next]",
        Ec = "flickity-disabled-mobile",
        Lc = "flickity-enabled";
    J("slideshow", [
        {
            onLoad() {
                yc[this.id] = new (class {
                    init() {
                        const t = {
                            autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                            contain: !1,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            accessibility: !0,
                            wrapAround: 2 !== this.slideCount,
                            prevNextButtons: !1,
                            draggable: !0,
                            fade: !0,
                            watchCSS: !0,
                        };
                        (this.flkty = new e(this.wrapper, t)),
                            this.prevButtons.length &&
                                this.prevButtons.forEach((t) => {
                                    t.onclick = () => {
                                        this.flkty.previous(!0, !1);
                                    };
                                }),
                            this.nextButtons.length &&
                                this.nextButtons.forEach((t) => {
                                    t.onclick = () => {
                                        this.flkty.next(!0, !1);
                                    };
                                }),
                            this.stopSlider(),
                            document.addEventListener("theme:resize", this.resizeEvent),
                            document.addEventListener("theme:scroll", this.scrollEvent);
                    }
                    scrollEvents() {
                        if (this.flkty && this.autoplay && this.speed) {
                            const t = this.flkty.element,
                                e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                            window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                        }
                    }
                    resizeEvents() {
                        this.stopSlider();
                    }
                    stopSlider() {
                        var t;
                        window.innerWidth < window.theme.sizes.medium && (null === (t = this.wrapper) || void 0 === t ? void 0 : t.classList.contains(Ec)) && new Se(this.container);
                    }
                    unload() {
                        document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.flkty.destroy();
                    }
                    onBlockSelect(t) {
                        const e = t.target.closest("[data-slideshow-index]").getAttribute("data-slideshow-index"),
                            i = parseInt(e, 10);
                        this.flkty && this.flkty.element && this.flkty.element.classList.contains(Lc) && (this.flkty.selectCell(i), this.flkty.pausePlayer());
                    }
                    onBlockDeselect() {
                        this.autoplay && this.flkty.unpausePlayer();
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.wrapper = this.container.querySelector(fc)),
                            (this.speed = this.wrapper.getAttribute(gc)),
                            (this.autoplay = "true" === this.wrapper.getAttribute(vc)),
                            (this.slideCount = parseInt(this.wrapper.getAttribute(wc), 10)),
                            (this.prevButtons = this.wrapper.querySelectorAll(bc)),
                            (this.nextButtons = this.wrapper.querySelectorAll(Sc)),
                            (this.flkty = null),
                            (this.scrollEvent = () => this.scrollEvents()),
                            (this.resizeEvent = () => this.resizeEvents()),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                "function" == typeof yc[this.id].unload && yc[this.id].unload();
            },
            onBlockSelect(t) {
                "function" == typeof yc[this.id].onBlockSelect && yc[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                "function" == typeof yc[this.id].onBlockSelect && yc[this.id].onBlockDeselect(t);
            },
        },
        mc,
        rr,
    ]),
        J("team", [jn, rr]);
    var kc = {};
    function Tc(t) {
        return kc[t];
    }
    (kc.basic = []),
        (kc.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (kc.light_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (kc.white_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (kc.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (kc.dark_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (kc.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let Ac = window.theme.allMaps;
    J("section-map", {
        onLoad() {
            Ac[this.id] = new (class {
                initMaps() {
                    Oe({ url: `https://maps.googleapis.com/maps/api/js?key=${this.key}` })
                        .then(() => {
                            return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long
                                ? new window.google.maps.LatLng(this.lat, this.long)
                                : ((t = this.address),
                                  new Promise((e, i) => {
                                      new window.google.maps.Geocoder().geocode({ address: t }, function (t, s) {
                                          if ("OK" == s) {
                                              var o = { lat: t[0].geometry.location.lat(), lng: t[0].geometry.location.lng() };
                                              e(o);
                                          } else i(s);
                                      });
                                  }));
                            var t;
                        })
                        .then((t) => {
                            var e = { zoom: parseInt(this.zoomString, 10), styles: Tc(this.styleString), center: t, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 };
                            const i = (function (t, e) {
                                var i = new window.google.maps.Map(t, e),
                                    s = i.getCenter();
                                return (
                                    new window.google.maps.Marker({ map: i, position: s }),
                                    window.google.maps.event.addDomListener(window, "resize", function () {
                                        window.google.maps.event.trigger(i, "resize"), i.setCenter(s);
                                    }),
                                    i
                                );
                            })(this.mapWrap, e);
                            return i;
                        })
                        .then((t) => {
                            (this.map = t), (Ac[this.id] = t);
                        })
                        .catch((t) => {
                            console.log("Failed to load Google Map"), console.log(t);
                        });
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.mapWrap = this.container.querySelector("[data-map-container]")),
                        (this.styleString = this.container.getAttribute("data-style") || ""),
                        (this.key = this.container.getAttribute("data-api-key")),
                        (this.zoomString = this.container.getAttribute("data-zoom") || 14),
                        (this.address = this.container.getAttribute("data-address")),
                        (this.enableCorrection = this.container.getAttribute("data-latlong-correction")),
                        (this.lat = this.container.getAttribute("data-lat")),
                        (this.long = this.container.getAttribute("data-long")),
                        this.key && this.initMaps();
                }
            })(this);
        },
        onUnload() {
            "function" == typeof Ac[this.id].unload && Ac[this.id].unload();
        },
    }),
        J("hero", [ir, mc]),
        J("video", [mc, tr]);
    const qc = "[data-video-button]",
        xc = "[data-background-video]",
        Cc = "data-unique",
        Pc = "data-video-id",
        $c = "data-video-type",
        _c = "data-video-autoplay",
        Dc = "data-video-loop",
        Ic = "[data-player]",
        Mc = "data-section-video-onload",
        Hc = "is-loaded";
    let Fc = {};
    J("video-player", {
        onLoad() {
            Fc[this.id] = new (class {
                init() {
                    this.triggers.length &&
                        ((this.button = this.triggers[0]),
                        this.videoOnLoad
                            ? this.loadVideos()
                            : this.triggers.forEach((t) => {
                                  t.addEventListener("click", (t) => this.loadVideos(t));
                              }));
                }
                loadVideos(t) {
                    if (
                        (t && t.currentTarget && (this.button = t.currentTarget),
                        this.button &&
                            ((this.unique = this.button.hasAttribute(Cc) ? this.button.getAttribute(Cc) : null),
                            (this.video = this.button.hasAttribute(Pc) ? this.button.getAttribute(Pc) : null),
                            (this.type = this.button.hasAttribute($c) ? this.button.getAttribute($c) : null),
                            (this.autoplay = !this.button.hasAttribute(_c) || "false" !== this.button.getAttribute(_c)),
                            (this.loop = !this.button.hasAttribute(Dc) || "false" !== this.button.getAttribute(Dc))),
                        this.unique && this.video && this.type)
                    ) {
                        const t = `${this.video}-${this.unique}`;
                        "vimeo" === this.type &&
                            (this.loadedVideoPlayer
                                ? (this.loadedVideoPlayer.play(), this.scrollToVideo(this.loadedVideoPlayer.element))
                                : Ve(t, { autoplay: this.autoplay, background: !1, loop: this.loop, controls: !0, muted: !0, playsinline: !0 })
                                      .then((t) => this.vimeoBackground(t))
                                      .catch((t) => {
                                          console.error(t);
                                      })),
                            "youtube" === this.type &&
                                (this.loadedVideoPlayer
                                    ? (this.loadedVideoPlayer.playVideo(), this.scrollToVideo(this.loadedVideoPlayer.getIframe()))
                                    : Jn(t, { autoplay: this.autoplay, cc_load_policy: 0, iv_load_policy: 0, modestbranding: 1, playsinline: 1, fs: 0, controls: 1, mute: 1 })
                                          .then((t) => this.youtubeBackground(t))
                                          .catch((t) => {
                                              console.error(t);
                                          }));
                    }
                }
                youtubeBackground(t) {
                    return (
                        (this.loadedVideoPlayer = t),
                        this.scrollToVideo(t.getIframe()),
                        t.addEventListener("onStateChange", (t) => {
                            0 === t.data && (this.loop ? t.target.playVideo() : (this.videoLoadedToggle(!0), this.nativeVideoEvents(!0))),
                                1 === t.data && (t.target.mute(), t.target.playVideo(), this.nativeVideoEvents(), this.videoLoadedToggle());
                        }),
                        t
                    );
                }
                vimeoBackground(t) {
                    return (
                        (this.loadedVideoPlayer = t),
                        this.scrollToVideo(t.element),
                        t.on("play", () => {
                            this.nativeVideoEvents(), this.videoLoadedToggle();
                        }),
                        t.on("ended", () => {
                            this.nativeVideoEvents(!0), this.videoLoadedToggle(!0);
                        }),
                        t
                    );
                }
                videoLoadedToggle(t = !1) {
                    this.container.classList.toggle(Hc, !t);
                }
                nativeVideoEvents(t = !1) {
                    this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && (t ? this.backgroundVideo.play() : this.backgroundVideo.pause());
                }
                scrollToVideo(t) {
                    const e = t.closest(Ic);
                    if (!this.videoOnLoad && e) {
                        const t = window.pageYOffset,
                            i = t + window.innerHeight,
                            s = e.getBoundingClientRect().top + window.scrollY,
                            o = s + e.offsetHeight;
                        (t > s || i < o) && window.scroll({ top: s, left: 0, behavior: "smooth" });
                    }
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.videoOnLoad = this.container.hasAttribute(Mc)),
                        (this.triggers = this.container.querySelectorAll(qc)),
                        (this.backgroundVideo = this.container.querySelector(xc)),
                        (this.button = null),
                        (this.unique = null),
                        (this.video = null),
                        (this.type = null),
                        (this.autoplay = !0),
                        (this.loop = !0),
                        (this.loadedVideoPlayer = null),
                        this.init();
                }
            })(this);
        },
        onUnload() {
            "function" == typeof Fc[this.id].unload && Fc[this.id].unload();
        },
    });
    const Bc = "[data-toggle-password-modal]",
        Wc = ".storefront-password-form .errors",
        Oc = {};
    J("password", {
        onLoad() {
            Oc[this.id] = new (class {
                init() {
                    yr("password"), this.errors && this.trigger.click();
                }
                constructor(t) {
                    (this.container = t.container), (this.trigger = this.container.querySelector(Bc)), (this.errors = this.container.querySelector(Wc)), this.init();
                }
            })(this);
        },
    });
    const Nc = "[data-image-zoom]",
        zc = "data-unique";
    const Vc = {
        onLoad() {
            new (class {
                init() {
                    this.triggers.forEach((t) => {
                        const e = t.getAttribute(zc);
                        r.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${e}`,
                            onShow: (t) => {
                                t.querySelectorAll("[data-src]", t).forEach((t) => {
                                    if (null === t.getAttribute("src")) {
                                        const e = t.getAttribute("data-src");
                                        t.setAttribute("src", e);
                                    }
                                });
                            },
                            onClose: (t, e, i) => {
                                i.preventDefault();
                            },
                        });
                    });
                }
                constructor(t) {
                    (this.triggers = t.querySelectorAll(Nc)), this.init();
                }
            })(this.container);
        },
    };
    J("gallery", [Vc, tr, Ee, rr]), J("recent-products", Qr);
    const Rc = {
            ajaxDisable: "data-ajax-disable",
            shipping: "[data-shipping-estimate-form]",
            input: "[data-update-cart]",
            update: "[data-update-button]",
            bottom: "[data-cart-bottom]",
            upsellProduct: "[data-upsell-holder]",
            upsellButton: "[data-add-action-wrapper]",
        },
        jc = {
            onLoad() {
                this.disabled = "true" == this.container.getAttribute(Rc.ajaxDisable);
                if ((this.container.querySelector(Rc.shipping) && new ce(this), this.disabled)) return void (this.cart = new Uc(this));
                this.cart = new Ui(this);
                this.cart.init().then(() => {
                    this.cart.loadHTML();
                });
            },
        };
    let Uc = class {
        initQuantity() {
            Ti(this.container);
        }
        moveUpsell() {
            const t = this.container.querySelector(Rc.bottom);
            t.insertBefore(this.upsellProduct, t.firstChild), new bi(this.section, !0);
        }
        initInputs() {
            this.inputs.forEach((t) => {
                t.addEventListener(
                    "change",
                    function () {
                        this.updateBtn.classList.add("cart--dirty"),
                            this.updateBtn.classList.add("heartBeat"),
                            setTimeout(
                                function () {
                                    this.updateBtn.classList.remove("heartBeat");
                                }.bind(this),
                                1300
                            );
                    }.bind(this)
                );
            });
        }
        constructor(t) {
            (this.section = t),
                (this.container = t.container),
                (this.inputs = this.container.querySelectorAll(Rc.input)),
                (this.quantityWrappers = this.container.querySelectorAll(Rc.qty)),
                (this.updateBtn = this.container.querySelector(Rc.update)),
                (this.upsellProduct = this.container.querySelector(Rc.upsellProduct)),
                this.initQuantity(),
                this.initInputs(),
                this.upsellProduct && this.moveUpsell();
        }
    };
    J("cart", [jc, yo]),
        J("search-page", [Do, Ro, An, yo]),
        customElements.get("popout-select") || customElements.define("popout-select", Ws),
        J("section-collection-grid", [jn, rr]),
        J("tabs", Yl),
        J("section-blog", jn),
        J("columns", [jn, rr]);
    const Jc = (t, e, i = null) => {
            (t.style.opacity = 0),
                (t.style.display = e || "block"),
                (function e() {
                    let s = parseFloat(t.style.opacity);
                    (s += 0.1) > 1 || ((t.style.opacity = s), requestAnimationFrame(e)), 1 === s && "function" == typeof i && i();
                })();
        },
        Yc = (t, e = null) => {
            (t.style.opacity = 1),
                (function i() {
                    (t.style.opacity -= 0.1) < 0 ? (t.style.display = "none") : requestAnimationFrame(i), 0 === parseFloat(t.style.opacity) && "function" == typeof e && e();
                })();
        },
        Kc = "[data-newsletter-form]",
        Xc = "has-success",
        Qc = "has-error",
        Gc = {};
    const Zc = {
            onLoad() {
                Gc[this.id] = [];
                this.container.querySelectorAll(Kc).forEach((t) => {
                    Gc[this.id].push(
                        new (class {
                            init() {
                                this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                            }
                            newsletterSubmitEvent(t) {
                                this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                            }
                            checkForChallengePage() {
                                this.isChallengePage = "/challenge" === window.location.pathname;
                            }
                            writeStorage() {
                                void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
                            }
                            readStorage() {
                                this.formID = this.sessionStorage.getItem("newsletter_form_id");
                            }
                            removeStorage() {
                                this.sessionStorage.removeItem("newsletter_form_id");
                            }
                            showMessage() {
                                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                    const t = document.getElementById(this.formID);
                                    -1 !== window.location.search.indexOf("?customer_posted=true")
                                        ? (t.classList.remove(Qc), t.classList.add(Xc))
                                        : -1 !== window.location.search.indexOf("accepts_marketing") && (t.classList.remove(Xc), t.classList.add(Qc)),
                                        this.scrollToForm(t);
                                }
                            }
                            scrollToForm(t) {
                                const e = t.getBoundingClientRect();
                                (e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                                    setTimeout(() => {
                                        window.scroll({ top: e.top, left: 0, behavior: "smooth" });
                                    }, 400);
                            }
                            unload() {
                                this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                            }
                            constructor(t) {
                                (this.sessionStorage = window.sessionStorage),
                                    (this.newsletter = t),
                                    (this.stopSubmit = !0),
                                    (this.isChallengePage = !1),
                                    (this.formID = null),
                                    this.checkForChallengePage(),
                                    (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                    this.isChallengePage || this.init();
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                Gc[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        th = "[data-tracking-consent]",
        eh = "[data-confirm-cookies]",
        ih = "[data-close-modal]",
        sh = "[data-popup-inner]",
        oh = "[data-newsletter]",
        nh = "[data-newsletter-holder]",
        rh = "[data-newsletter-field]",
        ah = "[data-newsletter-form]",
        lh = "[data-promo-text]",
        ch = "data-popup-delay",
        hh = "data-cookie-name",
        dh = "data-target-referrer",
        uh = "has-value",
        ph = "has-success",
        mh = "desktop",
        yh = "mobile";
    let fh = {},
        gh = class {
            write() {
                ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                    (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                    return document.cookie
                        .split("; ")
                        .find((t) => t.startsWith(this.name))
                        .split("=")[1];
                }
                return !1;
            }
            destroy() {
                document.cookie.split("; ").find((t) => t.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            constructor(t, e) {
                (this.configuration = { expires: null, path: "/", domain: window.location.hostname }), (this.name = t), (this.value = e);
            }
        },
        vh = class {
            always() {
                Jc(this.element);
            }
            delayed() {
                setTimeout(() => {
                    Jc(this.element);
                }, 1e4);
            }
            bottom() {
                window.addEventListener("scroll", () => {
                    window.scrollY + window.innerHeight >= document.body.clientHeight && Jc(this.element);
                });
            }
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), Jc(this.element);
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s();
                    };
                s();
            }
            constructor(t, e) {
                (this.element = e), (this.delay = t.getAttribute(ch)), "always" === this.delay && this.always(), "delayed" === this.delay && this.delayed(), "bottom" === this.delay && this.bottom(), "idle" === this.delay && this.idle();
            }
        },
        wh = class {
            init() {
                -1 === this.locationPath.indexOf(this.el.getAttribute(dh)) && this.el.parentNode.removeChild(this.el);
            }
            constructor(t) {
                (this.el = t), (this.locationPath = location.href), this.el.hasAttribute(dh) && this.init();
            }
        };
    J("popups", [
        Zc,
        {
            onLoad() {
                fh[this.id] = [];
                this.container.querySelectorAll(th).forEach((t) => {
                    fh[this.id].push(
                        new (class {
                            init() {
                                this.showPopup && Jc(this.modalInner), this.clickEvents();
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => Yc(this.modalInner));
                                }),
                                    this.acceptButton.addEventListener("click", (t) => {
                                        t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => Yc(this.modalInner));
                                    }),
                                    document.addEventListener("trackingConsentAccepted", function () {
                                        console.log("trackingConsentAccepted event fired");
                                    });
                            }
                            onBlockSelect(t) {
                                this.popup.contains(t.target) &&
                                    setTimeout(() => {
                                        Jc(this.modalInner);
                                    }, 400);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && Yc(this.modalInner);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.modal = document.querySelector(th)),
                                    (this.modalInner = this.popup.querySelector(sh)),
                                    (this.close = this.modal.querySelector(ih)),
                                    (this.acceptButton = this.modal.querySelector(eh)),
                                    (this.enable = "true" === this.modal.getAttribute("data-enable")),
                                    (this.showPopup = !1),
                                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                        if (t) throw t;
                                        const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                            i = window.Shopify.customerPrivacy.getTrackingConsent();
                                        (this.showPopup = !e && "no_interaction" === i && this.enable), window.Shopify.designMode && ((this.showPopup = !1), Yc(this.modalInner)), this.init();
                                    });
                            }
                        })(t)
                    );
                });
                this.container.querySelectorAll(oh).forEach((t) => {
                    fh[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (this.show(), this.form.classList.contains(ph) && this.checkForSuccess());
                            }
                            show() {
                                window.Shopify.designMode || new vh(this.popup, this.popupInner), this.inputField(), this.closePopup();
                            }
                            checkForSuccess() {
                                Jc(this.popupInner), this.cookie.write();
                            }
                            closePopup() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), Yc(this.popupInner), this.cookie.write();
                                });
                            }
                            inputField() {
                                this.newsletterField.addEventListener("input", () => {
                                    "" !== this.newsletterField.value && this.holder.classList.add(uh, "" !== this.newsletterField.value);
                                }),
                                    this.newsletterField.addEventListener("focus", () => {
                                        "" !== this.newsletterField.value && this.holder.classList.add(uh, "" !== this.newsletterField.value);
                                    }),
                                    this.newsletterField.addEventListener("focusout", () => {
                                        setTimeout(() => {
                                            this.holder.classList.remove(uh);
                                        }, 2e3);
                                    });
                            }
                            onBlockSelect(t) {
                                this.popup.classList.contains(yh) && (this.hasDeviceClass = yh),
                                    this.popup.classList.contains(mh) && (this.hasDeviceClass = mh),
                                    "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass),
                                    this.popup.contains(t.target) &&
                                        setTimeout(() => {
                                            Jc(this.popupInner);
                                        }, 400);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && Yc(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.popupInner = this.popup.querySelector(sh)),
                                    (this.holder = this.popup.querySelector(nh)),
                                    (this.close = this.popup.querySelector(ih)),
                                    (this.newsletterField = this.popup.querySelector(rh)),
                                    (this.cookie = new gh(this.popup.getAttribute(hh), "newsletter_is_closed")),
                                    (this.form = this.popup.querySelector(ah)),
                                    (this.isTargeted = new wh(this.popup)),
                                    (this.hasDeviceClass = ""),
                                    this.init();
                            }
                        })(t)
                    );
                });
                this.container.querySelectorAll(lh).forEach((t) => {
                    fh[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (window.Shopify.designMode || new vh(this.popup, this.popupInner), this.clickEvents());
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), Yc(this.popupInner), this.cookie.write();
                                });
                            }
                            onBlockSelect(t) {
                                this.popup.classList.contains(yh) && (this.hasDeviceClass = yh),
                                    this.popup.classList.contains(mh) && (this.hasDeviceClass = mh),
                                    "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass),
                                    this.popup.contains(t.target) &&
                                        setTimeout(() => {
                                            Jc(this.popupInner);
                                        }, 400);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && Yc(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.popupInner = this.popup.querySelector(sh)),
                                    (this.close = this.popup.querySelector(ih)),
                                    (this.cookie = new gh(this.popup.getAttribute(hh), "user_has_closed")),
                                    (this.isTargeted = new wh(this.popup)),
                                    (this.hasDeviceClass = ""),
                                    this.init();
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                fh[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                fh[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
    ]),
        J("newsletter", [Zc]),
        J("section-icons", [jn, rr]);
    const bh = {},
        Sh = "[data-slider-logo]",
        Eh = "[data-slider-text]",
        Lh = "data-slide",
        kh = "data-slide-index",
        Th = "flickity-enabled",
        Ah = "is-selected",
        qh = 200;
    J("press", [
        {
            onLoad() {
                bh[this.id] = new (class {
                    init() {
                        (this.flkty = new e(this.slideshowText, { fade: !0, autoPlay: !1, prevNextButtons: !1, cellAlign: "left", contain: !0, pageDots: !1, wrapAround: !1, selectedAttraction: 0.2, friction: 0.6, draggable: !1 })),
                            this.clickSliderNavEvents(),
                            this.initSliderNav();
                    }
                    calculateMarginTextSlides() {
                        const t = this.slideshowText.querySelectorAll(`[${Lh}]`);
                        if (t.length) {
                            const e = Math.max.apply(
                                null,
                                [...t].map((t) => t.clientHeight || t.offsetHeight)
                            );
                            t.forEach((t) => {
                                const i = t.clientHeight || t.offsetHeight;
                                if (i < e) {
                                    const s = Math.ceil((e - i) / 2);
                                    t.style.margin = `${s}px 0`;
                                }
                            });
                        }
                    }
                    initSliderNav() {
                        this.activeSliderNav(), this.setDefaultStatesOnSliderNav(), this.calculateMarginTextSlides(), window.addEventListener("resize", this.resizeEvent);
                    }
                    setDefaultStatesOnSliderNav() {
                        const t = this.sliderNav.querySelector(`.${Ah}`);
                        t && (t.classList.remove(Ah), this.logoSlides[0].classList.add(Ah)),
                            this.sliderNavAvailable
                                ? null === this.flktyNav &&
                                  ((this.flktyNav = new l(this.sliderNav, { prevNextButtons: !1, contain: !0, pageDots: !1, wrapAround: !0, watchCSS: !0, selectedAttraction: 0.05, friction: 0.8, initialIndex: 0, freeScroll: !0 })),
                                  this.flktyNav && (this.flkty.select(0), this.flktyNav.on("change", (t) => this.flkty.select(t)), this.flktyNav.resize()))
                                : (null !== this.flktyNav && (this.flktyNav.destroy(), (this.flktyNav = null)), this.logoSlides[0].classList.add(Ah), this.flkty && this.flkty.select(0));
                    }
                    clickSliderNavEvents() {
                        this.logoSlides.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                const e = t.currentTarget,
                                    i = Number(e.getAttribute(kh)),
                                    s = this.sliderNav.classList.contains(Th);
                                if ((this.flkty && this.flkty.select(i), s && this.flktyNav.select(i), !s)) {
                                    const t = this.sliderNav.querySelector(`.${Ah}`);
                                    t && t.classList.remove(Ah), e.classList.add(Ah);
                                }
                            });
                        });
                    }
                    activeSliderNav() {
                        const t = this.sliderNav.querySelectorAll(`[${Lh}]`).length,
                            e = this.sliderNav.parentNode.offsetWidth || this.sliderNav.parentNode.clientWidth,
                            i = t * qh;
                        this.sliderNavAvailable = i > e;
                    }
                    onUnload() {
                        this.flktyNav && this.flktyNav.destroy(), this.flkty && this.flkty.destroy(), window.removeEventListener("resize", this.resizeEvent);
                    }
                    onBlockSelect(t) {
                        if (!this.sliderNav) return;
                        const e = this.sliderNav.querySelector(`[${Lh}="${t.detail.blockId}"]`),
                            i = parseInt(e.getAttribute(kh));
                        this.calculateMarginTextSlides(), this.flkty && this.flkty.select(i), this.sliderNav.classList.contains(Ah) ? (this.sliderNav.classList.add(Ah), this.sliderNav.select(i)) : e.dispatchEvent(new Event("click"));
                    }
                    onSelect() {
                        window.removeEventListener("resize", this.resizeEvent), this.initSliderNav();
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.sliderNav = this.container.querySelector(Sh)),
                            (this.slideshowText = this.container.querySelector(Eh)),
                            (this.flkty = null),
                            (this.flktyNav = null),
                            this.sliderNav && this.slideshowText && ((this.logoSlides = this.sliderNav.querySelectorAll(`[${Lh}]`)), (this.resizeEvent = u(() => this.initSliderNav(), 500)), this.init());
                    }
                })(this);
            },
            onUnload(t) {
                bh[this.id].onUnload(t);
            },
            onSelect() {
                "press" === this.type && bh[this.id].onSelect();
            },
            onBlockSelect(t) {
                bh[this.id].onBlockSelect(t);
            },
        },
        rr,
    ]),
        J("logo-list", [Ee, rr]);
    const xh = (t, e = "", i) => ((i = i || document.createElement("div")).classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)),
        Ch = {};
    function Ph(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Ch[t.url]
                ? Ch[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : Be(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (Ch[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return Ch[t.json]
                ? Promise.resolve(Ch[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Ch[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Ch[e]
                ? Ch[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (Ch[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    document.addEventListener("DOMContentLoaded", function () {
        Y("*");
        document.querySelectorAll(".rte table").forEach((t) => {
            xh(t, "rte__table-wrapper");
        });
        document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t) => {
            xh(t, "rte__video-wrapper");
        }),
            document.addEventListener("mousedown", () => {
                document.body.classList.remove("focus-enabled");
            }),
            document.addEventListener("keyup", (t) => {
                9 === t.keyCode && document.body.classList.add("focus-enabled");
            }),
            window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
            tt(),
            et(),
            "scrollBehavior" in document.documentElement.style || Ph({ url: window.theme.assets.smoothscroll });
    });
})(themeVendor.ScrollLock, themeVendor.FlickityFade, themeVendor.themeCurrency, themeVendor.themeAddresses, themeVendor.Sqrl, themeVendor.axios, themeVendor.MicroModal, themeVendor.FlickitySync, themeVendor.Flickity, themeVendor.Rellax);
